<template>
  <div class="front-wrapper min-vh-100 p-0 patient-change-regimen-new">
    <header class="main-header">
      <div class="container container-md-lg">
        <div class="header-wrap wrap-lg">
          <div class="header-logo">
            <router-link
              :to="{
                name: 'userdashboard'
              }"
            >
              <img
                :src="logo"
                alt="Logo"
              >
            </router-link>
          </div>
          <div class="header-right">
            <div class="header-center">
              <p v-if="patient.name">
                Client Name:
                <strong>{{ patient.first_name }} {{ patient.last_name }}</strong>
              </p>
              <p v-if="patient.physician">
                Skincare Pro Name:
                <strong>{{ patient.physician && patient.physician.name }}</strong>
              </p>
            </div>
            <p class="text-soft pt-1">
              Add and remove products from your client's regimen
            </p>
          </div>
          <div class="header-right-link">
            <a
              href="#"
              @click.prevent="leaveWithoutSaving"
            >Back</a>
          </div>
        </div>
      </div>
    </header>
    <div class="frontend-main p-0 m-0">
      <div class="container container-md-xs">
        <Notifications />
      </div>
      <div class="container-fluid p-0">
        <!-- Two Panel Layout -->
        <div class="partition">
          <!-- Left Panel: Add Product -->
          <div class="partition-left">
            <div class="section-top">
              <h3 class="panel-title">Add product</h3>

              <!-- Search Bar -->
              <div class="search-bar">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M19 19L14.65 14.65" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input
                  v-model="search"
                  type="text"
                  placeholder="Search product by name"
                  @input="searchProduct"
                >
              </div>

              <!-- Filters -->
              <div class="filters-container">
                <h4 class="filters-title">Filters</h4>
                <div class="row">  
                  <div class="col-sm-3 custom-form form-filter">
                      <div class="form1-items">
                        <label>
                          <input
                            v-model="productsType"
                            type="radio"
                            value=""
                            name="productsType"
                            @change="fetchData"
                          >
                          <span class="type-heading">All Products</span>
                        </label>
                      </div>

                      <div class="form1-items">
                        <label>
                          <input
                            v-model="productsType"
                            type="radio"
                            value="presetProducts"
                            name="productsType"
                          >
                          <span class="type-heading">Preset Regimens</span>
                        </label>
                      </div>

                      <div class="form1-items">
                        <label>
                          <input
                            v-model="productsType"
                            type="radio"
                            value="topPicks"
                            name="productsType"
                            @change="fetchData"
                          >
                          <span class="type-heading">Top Picks</span>
                        </label>
                      </div>

                      <div class="form1-items">
                        <label>
                          <input
                            v-model="productsType"
                            type="radio"
                            value="recentPurchase"
                            name="productsType"
                            @change="fetchData"
                          >
                          <span class="type-heading">Recent Purchase</span>
                        </label>
                      </div>
                    </div>

                  <div class="col-sm-9">  
                    <div v-if="productsType !== 'presetProducts'" class="filters-grid">
                      <filter-select v-model="brand"      :items="brands"      default-value="All Brands" name="brands-select"      class="filter-dropdown" />
                      <filter-select v-model="concern"    :items="concerns"    default-value="All Concerns"        name="concerns-select"    class="filter-dropdown" />
                      <filter-select v-model="category"   :items="categories"  default-value="All Types"      name="categories-select"  class="filter-dropdown" />
                      <filter-select v-model="ingredient" :items="ingredients" default-value="All Ingredients"     name="ingredients-select" class="filter-dropdown" />
                    </div>

                    <div v-if="productsType === 'presetProducts'" class="filters-grid">
                      <select
                        v-model="concernSelected"
                        class="filter-dropdown"
                      >
                        <option
                          value=""
                          selected
                        >
                          All Concerns
                        </option>

                        <option
                          v-for="tag in regimenTags"
                          :key="tag.name"
                          :value="tag.name"
                        >
                          {{ tag.value }}
                        </option>
                      </select>
                        
                      <select
                        v-model="creators"
                        class="filter-dropdown"
                      >
                        <option
                          value=""
                          selected
                        >
                          All Creators
                        </option>

                        <option
                          v-if="patient.practice && patient.practice.id"
                          :value="patient.practice.id"
                        >
                          Practice Created
                        </option>

                        <option value="superadmin">
                          RegimenPro® Created
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Search Status and Active Filters -->
              <div v-if="isSearching || searchCompleted || activeFilters.length > 0" class="search-status-section">
                <!-- Search Indicator -->
                <div v-if="isSearching" class="search-indicator searching">
                  <svg class="spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" stroke-opacity="0.25"/>
                    <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                  <span>Searching...</span>
                </div>
                <div v-else-if="searchCompleted" class="search-indicator completed">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>Search complete</span>
                </div>

                <!-- Active Filter Tags -->
                <div v-if="activeFilters.length > 0" class="active-filters">
                  <div class="filter-tags">
                    <button 
                      v-for="filter in activeFilters" 
                      :key="filter.type"
                      class="filter-tag"
                      @click="removeFilter(filter.type)"
                      :title="`Remove ${filter.type} filter`"
                    >
                      <span class="filter-tag-label">{{ filter.label }}</span>
                      <svg class="filter-tag-close" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </button>
                    <button class="clear-all-filters" @click="clearAllFilters">
                      Clear all
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ── PRESCRIPTION SECTION (NEW) ── -->
              <div class="prescription-section">
                <div class="prescription-header">
                  <p class="prescription-title">Prescription:</p>
                  <p class="prescription-sub">Drag the Prescription Badge into the desired spot on the regimen</p>
                </div>
                <div class="prescription-row">
                  <!-- Draggable Rx badge -->
                  <div 
                    class="rx-badge" 
                    draggable="true"
                    @dragstart="startDragRx($event)"
                  >
                    <span class="rx-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                        <path d="M7.45728 9.74983L8.85377 8.3534C8.94744 8.25961 9.00004 8.13247 9 7.99992C8.99996 7.86737 8.94728 7.74027 8.85355 7.64654C8.75982 7.55281 8.63271 7.50014 8.50015 7.5001C8.3676 7.50006 8.24045 7.55265 8.14666 7.64632L6.75017 9.04275L4.14305 6.43575C4.93316 6.27628 5.63583 5.82892 6.11463 5.18052C6.59343 4.53212 6.8142 3.72894 6.73407 2.92693C6.65395 2.12491 6.27865 1.38127 5.68103 0.840402C5.08342 0.299531 4.30614 1.27586e-05 3.50009 0H0.500013C0.367402 1.32604e-06 0.240222 0.0526793 0.146452 0.146446C0.0526816 0.240212 1.32609e-06 0.367386 0 0.499991V9.99982C0 10.1324 0.0526799 10.2596 0.14645 10.3534C0.240221 10.4471 0.367401 10.4998 0.500013 10.4998C0.632625 10.4998 0.759805 10.4471 0.853575 10.3534C0.947346 10.2596 1.00003 10.1324 1.00003 9.99982V6.49989H2.79298L6.04306 9.74983L4.64657 11.1463C4.6001 11.1927 4.56322 11.2478 4.53805 11.3085C4.51289 11.3691 4.49992 11.4342 4.4999 11.4999C4.49988 11.5655 4.51281 11.6306 4.53793 11.6913C4.56306 11.752 4.5999 11.8071 4.64635 11.8536C4.6928 11.9 4.74794 11.9368 4.80864 11.962C4.86933 11.9871 4.93438 12 5.00006 12C5.06575 12 5.13079 11.987 5.19147 11.9619C5.25214 11.9367 5.30726 11.8998 5.35368 11.8533L6.75017 10.4569L8.14666 11.8533C8.24045 11.947 8.3676 11.9996 8.50015 11.9996C8.63271 11.9995 8.75982 11.9468 8.85355 11.8531C8.94728 11.7594 8.99996 11.6323 9 11.4997C9.00004 11.3672 8.94744 11.24 8.85377 11.1463L7.45728 9.74983ZM1.00003 5.4999V0.999982H3.50009C4.09684 0.999982 4.66915 1.23703 5.09112 1.65898C5.51309 2.08093 5.75015 2.65322 5.75015 3.24994C5.75015 3.84667 5.51309 4.41896 5.09112 4.8409C4.66915 5.26285 4.09684 5.4999 3.50009 5.4999H1.00003Z" fill="black"/>
                      </svg>
                    </span>
                    <span>Prescription</span>
                  </div>

                  <!-- AM button -->
                  <button class="time-btn" title="Morning" @click="addRxProduct('morning', false)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="4"/>
                      <line x1="12" y1="2"  x2="12" y2="4"/>
                      <line x1="12" y1="20" x2="12" y2="22"/>
                      <line x1="4.22" y1="4.22"   x2="5.64"  y2="5.64"/>
                      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                      <line x1="2"  y1="12" x2="4"  y2="12"/>
                      <line x1="20" y1="12" x2="22" y2="12"/>
                      <line x1="4.22"  y1="19.78" x2="5.64"  y2="18.36"/>
                      <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22"/>
                    </svg>
                  </button>

                  <!-- PM button -->
                  <button class="time-btn" title="Evening" @click="addRxProduct('evening', false)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                    </svg>
                  </button>

                  <!-- AM+PM button -->
                  <button class="time-btn time-btn--both" title="Both" @click="addRxProductToBoth">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="4"/>
                      <line x1="12" y1="2"  x2="12" y2="4"/>
                      <line x1="12" y1="20" x2="12" y2="22"/>
                      <line x1="4.22" y1="4.22"   x2="5.64"  y2="5.64"/>
                      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                      <line x1="2"  y1="12" x2="4"  y2="12"/>
                      <line x1="20" y1="12" x2="22" y2="12"/>
                      <line x1="4.22"  y1="19.78" x2="5.64"  y2="18.36"/>
                      <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22"/>
                    </svg>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                    </svg>
                  </button>

                </div>
              </div>
            
            
            <PresetRegimenNew
              v-if="productsType === 'presetProducts'"
              class="products-section"
              :patient="patient"
              :creators="creators"
              :concerns="concernSelected"
              :morning-products="morningProducts"
              :evening-products="eveningProducts"
              @open-preset-product="handlePresetProduct"
            />
            <!-- Products Section -->
            <div v-else class="products-section">
              <h4 class="section-title">Products</h4>

              <div v-if="sending" class="loading-state">Loading products...</div>
              <div v-else-if="!products.length" class="no-products">No products found</div>

              <div v-else class="products-list">
                <div
                  v-for="product in filteredProducts"
                  :key="product.id"
                  class="product-wrapper"
                  draggable="true"
                  @dragstart="startDragProduct($event, product)"
                >
                  <div class="product-item">

                    <!-- Image + stacked name / vendor -->
                    <div class="product-info-wrapper">
                      <img
                        :src="(product.images && product.images.edges && product.images.edges[0] && product.images.edges[0].node && product.images.edges[0].node.url) || (product.images && product.images[0] && product.images[0].url) || '/images/product-placeholder.jpg'"
                        :alt="product.title"
                        class="product-image"
                      >
                      <div class="product-details">
                        <p class="product-name">{{ product.title }}</p>
                        <p class="product-vendor">{{ product.vendor }}</p>
                      </div>
                    </div>

                    <!-- View Details + time buttons -->
                    <div class="product-actions">
                      <a href="#" class="btn-view" @click.prevent="toggleProduct(product.id)">
                        {{ expandedProduct === product.id ? 'Close Details' : 'View Details' }}
                      </a>

                      <div class="time-actions">
                        <!-- AM -->
                        <button 
                          class="time-btn" 
                          title="Morning" 
                          @click="addProductToRegimen(product, 'am')"
                          :disabled="isProductInMorning(product)"
                          :class="{ 'disabled': isProductInMorning(product) }"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="4"/>
                            <line x1="12" y1="2"  x2="12" y2="4"/>
                            <line x1="12" y1="20" x2="12" y2="22"/>
                            <line x1="4.22" y1="4.22"   x2="5.64"  y2="5.64"/>
                            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                            <line x1="2"  y1="12" x2="4"  y2="12"/>
                            <line x1="20" y1="12" x2="22" y2="12"/>
                            <line x1="4.22"  y1="19.78" x2="5.64"  y2="18.36"/>
                            <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22"/>
                          </svg>
                        </button>
                        <!-- PM -->
                        <button 
                          class="time-btn" 
                          title="Evening" 
                          @click="addProductToRegimen(product, 'pm')"
                          :disabled="isProductInEvening(product)"
                          :class="{ 'disabled': isProductInEvening(product) }"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                          </svg>
                        </button>
                        <!-- AM + PM -->
                        <button 
                          class="time-btn time-btn--both" 
                          title="Both AM & PM" 
                          @click="addProductToRegimen(product, 'both')"
                          :disabled="isProductInMorning(product) && isProductInEvening(product)"
                          :class="{ 'disabled': isProductInMorning(product) && isProductInEvening(product) }"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="4"/>
                            <line x1="12" y1="2"  x2="12" y2="4"/>
                            <line x1="12" y1="20" x2="12" y2="22"/>
                            <line x1="4.22" y1="4.22"   x2="5.64"  y2="5.64"/>
                            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                            <line x1="2"  y1="12" x2="4"  y2="12"/>
                            <line x1="20" y1="12" x2="22" y2="12"/>
                            <line x1="4.22"  y1="19.78" x2="5.64"  y2="18.36"/>
                            <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22"/>
                          </svg>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Expandable Description -->
                  <div v-if="expandedProduct === product.id" class="product-description">
                    <div v-if="product.descriptionHtml" class="description-content">
                      <h5>Description:</h5>
                      <div class="description-text" v-html="product.descriptionHtml" />
                    </div>
                    <div v-else class="description-content">
                      <p class="no-description">No description available for this product.</p>
                    </div>
                  </div>
                </div>
                 <!-- Pagination -->
              <div class="pagination-wrap">
                <div class="pagination-l">
                  <div class="page-results">
                    Display
                    <select v-model="productsPerPage" @change="changePerPage">
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="40">40</option>
                      <option value="50">50</option>
                    </select>
                    results per page
                  </div>
                </div>
                <div class="pagination-r">
                  <nav class="pagination">
                    <ul class="pagination">
                      <li>
                        <a href="#" :class="{ disabled: !hasPreviousPage }" @click.prevent="hasPreviousPage && showPrevProducts()">
                          <i class="fas fa-angle-left" />
                        </a>
                      </li>
                      <li>
                        <a href="#" :class="{ disabled: !hasNextPage }" @click.prevent="hasNextPage && getMoreProducts()">
                          <i class="fas fa-angle-right" />
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              </div>
            </div>
          </div>

          <!-- Right Panel: Regimen Name -->
          <div 
            class="partition-right"
            @dragleave="onDragLeavePartition($event)"
            @dragenter.prevent="onDragEnterPartition($event)"
            @drop="onDropInPartition($event)"
          >

            <div class="regimen-header">
              <h1 class="regimen-title">Clients Regimen</h1>
              <p class="regimen-subtitle">Drag and drop to rearrange products, drag off Regimen to remove entirely.</p>
            </div>

            <div 
              v-for="pageIndex in totalPages" 
              :key="'page-' + pageIndex"
              class="regimen-preview-block"
            >
              <div class="regimen-brand p-2 px-4">
                <span class="brand-name">
                  <img 
                    src="../../../../images/preview-logo.png" 
                    alt="Logo"
                    :class="{'no-border': !(patient.practice && patient.practice.logo && patient.practice.logo.url)}"
                  >
                  <img v-if="patient.practice && patient.practice.logo && patient.practice.logo.url" :src="patient.practice.logo.url" alt="Practice Logo">
                </span>
                <div class="client-details">
                  <p class="m-0">
                    <strong> Client Name : </strong> {{ patient.first_name }} {{ patient.last_name }}
                  </p>
                  <p class="m-0">
                    <strong> Provider : </strong> {{ patient.physician && patient.physician.name }}
                  </p>
                  <p class="m-0">
                    <strong> Last Modified By : </strong> {{ lastEditedBy }}
                  </p>
                  <p class="m-0">
                    <strong> Last Modified At : </strong> {{ lastEditedAt }}
                  </p>
                </div>
              </div>

              <!-- Morning + Evening columns -->
              <div class="regimen-columns">

                <!-- Morning -->
                <div class="regimen-col-morning">
                  <div class="regimen-col-title">Morning Regimen</div>

                  <draggable 
                    :list="getMorningProductsForPage(pageIndex - 1)" 
                    :options="dragOptions"
                    @change="handlePaginatedDragChange($event, 'morning', pageIndex - 1)"
                    @start="onDragStart($event, 'morning', pageIndex - 1)"
                    @end="onDragEnd($event)"
                    class="draggable-container"
                    data-section="morning"
                    :move="checkMove"
                  >
                    <div 
                      v-for="(product, index) in getMorningProductsForPage(pageIndex - 1)" 
                      :key="product.variant_graph_id || index"
                      class="drop-zone-wrapper"
                      :class="{ 'dragging-to-remove': isDraggingOutside && draggedProduct === product }"
                    >
                      <div class="drop-zone with-product d-flex justify-content-between">
                        <span class="product-number">{{ (pageIndex - 1) * 8 + index + 1 }}</span>
                        <div class="product-name d-flex flex-column text-left">
                          <!-- Rx Badge for prescription products -->
                          <div v-if="product.handle === 'rx'" class="rx-badge">
                            <span class="rx-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                        <path d="M7.45728 9.74983L8.85377 8.3534C8.94744 8.25961 9.00004 8.13247 9 7.99992C8.99996 7.86737 8.94728 7.74027 8.85355 7.64654C8.75982 7.55281 8.63271 7.50014 8.50015 7.5001C8.3676 7.50006 8.24045 7.55265 8.14666 7.64632L6.75017 9.04275L4.14305 6.43575C4.93316 6.27628 5.63583 5.82892 6.11463 5.18052C6.59343 4.53212 6.8142 3.72894 6.73407 2.92693C6.65395 2.12491 6.27865 1.38127 5.68103 0.840402C5.08342 0.299531 4.30614 1.27586e-05 3.50009 0H0.500013C0.367402 1.32604e-06 0.240222 0.0526793 0.146452 0.146446C0.0526816 0.240212 1.32609e-06 0.367386 0 0.499991V9.99982C0 10.1324 0.0526799 10.2596 0.14645 10.3534C0.240221 10.4471 0.367401 10.4998 0.500013 10.4998C0.632625 10.4998 0.759805 10.4471 0.853575 10.3534C0.947346 10.2596 1.00003 10.1324 1.00003 9.99982V6.49989H2.79298L6.04306 9.74983L4.64657 11.1463C4.6001 11.1927 4.56322 11.2478 4.53805 11.3085C4.51289 11.3691 4.49992 11.4342 4.4999 11.4999C4.49988 11.5655 4.51281 11.6306 4.53793 11.6913C4.56306 11.752 4.5999 11.8071 4.64635 11.8536C4.6928 11.9 4.74794 11.9368 4.80864 11.962C4.86933 11.9871 4.93438 12 5.00006 12C5.06575 12 5.13079 11.987 5.19147 11.9619C5.25214 11.9367 5.30726 11.8998 5.35368 11.8533L6.75017 10.4569L8.14666 11.8533C8.24045 11.947 8.3676 11.9996 8.50015 11.9996C8.63271 11.9995 8.75982 11.9468 8.85355 11.8531C8.94728 11.7594 8.99996 11.6323 9 11.4997C9.00004 11.3672 8.94744 11.24 8.85377 11.1463L7.45728 9.74983ZM1.00003 5.4999V0.999982H3.50009C4.09684 0.999982 4.66915 1.23703 5.09112 1.65898C5.51309 2.08093 5.75015 2.65322 5.75015 3.24994C5.75015 3.84667 5.51309 4.41896 5.09112 4.8409C4.66915 5.26285 4.09684 5.4999 3.50009 5.4999H1.00003Z" fill="black"/>
                      </svg>
                    </span>
                            <span>Prescription</span>
                          </div>
                          <!-- Regular product display -->
                          <template v-else>
                            <p>{{ product.title }}</p>
                            <span>{{ product.vendor }}</span>
                          </template>
                          <a href="#" @click.prevent="removeProduct(product, 'morning')">Remove</a>
                        </div>
                        <img :src="product.image" alt="product thumbnail" class="product-thumbnail">
                      </div>
                      <div v-if="index < getMorningProductsForPage(pageIndex - 1).length - 1 || isLastMorningPage(pageIndex - 1)" class="arrow-down"><img src="../../../../images/pdf-down-arrow.png" alt="Down arrow"></div>
                    </div>
                  </draggable>

                  <div 
                    v-if="isLastMorningPage(pageIndex - 1)"
                    v-for="n in Math.max(1, 3 - getMorningProductsForPage(pageIndex - 1).length)"
                    :key="'morning-empty-' + n"
                    class="drop-zone-wrapper"
                  >
                    <div 
                      class="drop-zone"
                      @drop="onDropMorning($event)"
                      @dragover.prevent
                      @dragenter.prevent
                    >
                      + Drag product here to add
                    </div>
                    <div v-if="n < Math.max(1, 3 - getMorningProductsForPage(pageIndex - 1).length)" class="arrow-down"><img src="../../../../images/pdf-down-arrow.png" alt="Down arrow"></div>
                  </div>

                  <!-- Additional info (only on last page) -->
                  <template v-if="isLastMorningPage(pageIndex - 1)">
                    <div v-if="!morningAdditionalInfo" class="additional-info-section">
                      <a class="add-info-link" href="#" @click.prevent="openAdditionalInfoModal('morning')">Add Additional information</a>
                    </div>
                    <div v-else class="additional-info-section">
                      <div class="additional-info-title">
                        <p>Additional Information</p> 
                        <a class="edit-info-link" href="#" @click.prevent="openAdditionalInfoModal('morning')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.75C9 15.3358 9.33577 15 9.75 15H15.75C16.1642 15 16.5 15.3358 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H9.75C9.33577 16.5 9 16.1642 9 15.75Z" fill="#323232"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5802 6.07495C16.7875 4.86286 16.7362 3.27114 15.8347 2.29637C15.3951 1.82107 14.7694 1.51747 14.0608 1.50073C13.3495 1.48393 12.6125 1.75595 11.9325 2.32489C11.9151 2.33944 11.8984 2.35477 11.8824 2.37083L2.15584 12.1362C1.73582 12.5578 1.5 13.1288 1.5 13.724V14.9941C1.5 15.8203 2.16898 16.5 3.00287 16.5H4.26199C4.86028 16.5 5.43393 16.2617 5.85614 15.8378L15.5802 6.07495ZM12.9053 4.34471C12.6124 4.05182 12.1375 4.05182 11.8447 4.34471C11.5518 4.63761 11.5518 5.11248 11.8447 5.40538L12.5947 6.15537C12.8875 6.44826 13.3624 6.44826 13.6553 6.15537C13.9482 5.86248 13.9482 5.38761 13.6553 5.09471L12.9053 4.34471Z" fill="#323232"/>
                          </svg>
                        </a>
                      </div>
                      <p class="additional-info-text">{{ morningAdditionalInfo }}</p>
                    </div>

                    <!-- As Needed section -->
                    <div class="as-needed-divider"></div>
                    <div class="as-needed-label">As Needed</div>
                    
                    <draggable 
                      v-model="morningAsNeeded" 
                      :options="dragOptions"
                      @change="handleDragChange($event, 'morning-as-needed')"
                      @start="onDragStart($event, 'morning-as-needed')"
                      @end="onDragEnd($event)"
                      class="draggable-container"
                      data-section="morning-as-needed"
                      :move="checkMove"
                    >
                      <div 
                        v-for="(product, index) in morningAsNeeded" 
                        :key="product.variant_graph_id || index"
                        class="drop-zone-wrapper"
                        :class="{ 'dragging-to-remove': isDraggingOutside && draggedProduct === product }"
                      >
                        <div class="drop-zone with-product d-flex justify-content-between">
                          <span class="product-number">{{ index + 1 }}</span>
                          <div class="product-name d-flex flex-column text-left">
                            <!-- Rx Badge for prescription products -->
                            <div v-if="product.handle === 'rx'" class="rx-badge">
                              <span class="rx-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                        <path d="M7.45728 9.74983L8.85377 8.3534C8.94744 8.25961 9.00004 8.13247 9 7.99992C8.99996 7.86737 8.94728 7.74027 8.85355 7.64654C8.75982 7.55281 8.63271 7.50014 8.50015 7.5001C8.3676 7.50006 8.24045 7.55265 8.14666 7.64632L6.75017 9.04275L4.14305 6.43575C4.93316 6.27628 5.63583 5.82892 6.11463 5.18052C6.59343 4.53212 6.8142 3.72894 6.73407 2.92693C6.65395 2.12491 6.27865 1.38127 5.68103 0.840402C5.08342 0.299531 4.30614 1.27586e-05 3.50009 0H0.500013C0.367402 1.32604e-06 0.240222 0.0526793 0.146452 0.146446C0.0526816 0.240212 1.32609e-06 0.367386 0 0.499991V9.99982C0 10.1324 0.0526799 10.2596 0.14645 10.3534C0.240221 10.4471 0.367401 10.4998 0.500013 10.4998C0.632625 10.4998 0.759805 10.4471 0.853575 10.3534C0.947346 10.2596 1.00003 10.1324 1.00003 9.99982V6.49989H2.79298L6.04306 9.74983L4.64657 11.1463C4.6001 11.1927 4.56322 11.2478 4.53805 11.3085C4.51289 11.3691 4.49992 11.4342 4.4999 11.4999C4.49988 11.5655 4.51281 11.6306 4.53793 11.6913C4.56306 11.752 4.5999 11.8071 4.64635 11.8536C4.6928 11.9 4.74794 11.9368 4.80864 11.962C4.86933 11.9871 4.93438 12 5.00006 12C5.06575 12 5.13079 11.987 5.19147 11.9619C5.25214 11.9367 5.30726 11.8998 5.35368 11.8533L6.75017 10.4569L8.14666 11.8533C8.24045 11.947 8.3676 11.9996 8.50015 11.9996C8.63271 11.9995 8.75982 11.9468 8.85355 11.8531C8.94728 11.7594 8.99996 11.6323 9 11.4997C9.00004 11.3672 8.94744 11.24 8.85377 11.1463L7.45728 9.74983ZM1.00003 5.4999V0.999982H3.50009C4.09684 0.999982 4.66915 1.23703 5.09112 1.65898C5.51309 2.08093 5.75015 2.65322 5.75015 3.24994C5.75015 3.84667 5.51309 4.41896 5.09112 4.8409C4.66915 5.26285 4.09684 5.4999 3.50009 5.4999H1.00003Z" fill="black"/>
                      </svg>
                    </span>
                              <span>Prescription</span>
                            </div>
                            <!-- Regular product display -->
                            <template v-else>
                              <p>{{ product.title }}</p>
                              <span>{{ product.vendor }}</span>
                            </template>
                            <a href="#" @click.prevent="removeProduct(product, 'morning-as-needed')">Remove</a>
                          </div>
                          <img :src="product.image" alt="product thumbnail" class="product-thumbnail">
                        </div>
                        <div class="arrow-down"><img src="../../../../images/pdf-down-arrow.png" alt="Down arrow"></div>
                      </div>
                    </draggable>

                    <!-- Always show one empty drop zone for adding more products -->
                    <div class="drop-zone-wrapper">
                      <div 
                        class="drop-zone"
                        @drop="onDropMorningAsNeeded($event)"
                        @dragover.prevent
                        @dragenter.prevent
                      >
                        + Drag as needed product here
                      </div>
                    </div>
                  </template>
                </div>

                <!-- Evening -->
                <div class="regimen-col-evening">
                  <div class="regimen-col-title">Evening Regimen</div>

                  <draggable 
                    :list="getEveningProductsForPage(pageIndex - 1)" 
                    :options="dragOptions"
                    @change="handlePaginatedDragChange($event, 'evening', pageIndex - 1)"
                    @start="onDragStart($event, 'evening', pageIndex - 1)"
                    @end="onDragEnd($event)"
                    class="draggable-container"
                    data-section="evening"
                    :move="checkMove"
                  >
                    <div 
                      v-for="(product, index) in getEveningProductsForPage(pageIndex - 1)" 
                      :key="product.variant_graph_id || index"
                      class="drop-zone-wrapper"
                      :class="{ 'dragging-to-remove': isDraggingOutside && draggedProduct === product }"
                    >
                      <div class="drop-zone with-product d-flex justify-content-between">
                        <span class="product-number">{{ (pageIndex - 1) * 8 + index + 1 }}</span>
                        <div class="product-name d-flex flex-column text-left">
                          <!-- Rx Badge for prescription products -->
                          <div v-if="product.handle === 'rx'" class="rx-badge">
                            <span class="rx-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                        <path d="M7.45728 9.74983L8.85377 8.3534C8.94744 8.25961 9.00004 8.13247 9 7.99992C8.99996 7.86737 8.94728 7.74027 8.85355 7.64654C8.75982 7.55281 8.63271 7.50014 8.50015 7.5001C8.3676 7.50006 8.24045 7.55265 8.14666 7.64632L6.75017 9.04275L4.14305 6.43575C4.93316 6.27628 5.63583 5.82892 6.11463 5.18052C6.59343 4.53212 6.8142 3.72894 6.73407 2.92693C6.65395 2.12491 6.27865 1.38127 5.68103 0.840402C5.08342 0.299531 4.30614 1.27586e-05 3.50009 0H0.500013C0.367402 1.32604e-06 0.240222 0.0526793 0.146452 0.146446C0.0526816 0.240212 1.32609e-06 0.367386 0 0.499991V9.99982C0 10.1324 0.0526799 10.2596 0.14645 10.3534C0.240221 10.4471 0.367401 10.4998 0.500013 10.4998C0.632625 10.4998 0.759805 10.4471 0.853575 10.3534C0.947346 10.2596 1.00003 10.1324 1.00003 9.99982V6.49989H2.79298L6.04306 9.74983L4.64657 11.1463C4.6001 11.1927 4.56322 11.2478 4.53805 11.3085C4.51289 11.3691 4.49992 11.4342 4.4999 11.4999C4.49988 11.5655 4.51281 11.6306 4.53793 11.6913C4.56306 11.752 4.5999 11.8071 4.64635 11.8536C4.6928 11.9 4.74794 11.9368 4.80864 11.962C4.86933 11.9871 4.93438 12 5.00006 12C5.06575 12 5.13079 11.987 5.19147 11.9619C5.25214 11.9367 5.30726 11.8998 5.35368 11.8533L6.75017 10.4569L8.14666 11.8533C8.24045 11.947 8.3676 11.9996 8.50015 11.9996C8.63271 11.9995 8.75982 11.9468 8.85355 11.8531C8.94728 11.7594 8.99996 11.6323 9 11.4997C9.00004 11.3672 8.94744 11.24 8.85377 11.1463L7.45728 9.74983ZM1.00003 5.4999V0.999982H3.50009C4.09684 0.999982 4.66915 1.23703 5.09112 1.65898C5.51309 2.08093 5.75015 2.65322 5.75015 3.24994C5.75015 3.84667 5.51309 4.41896 5.09112 4.8409C4.66915 5.26285 4.09684 5.4999 3.50009 5.4999H1.00003Z" fill="black"/>
                      </svg>
                    </span>
                            <span>Prescription</span>
                          </div>
                          <!-- Regular product display -->
                          <template v-else>
                            <p>{{ product.title }}</p>
                            <span>{{ product.vendor }}</span>
                          </template>
                          <a href="#" @click.prevent="removeProduct(product, 'evening')">Remove</a>
                        </div>
                        <img :src="product.image" alt="product thumbnail" class="product-thumbnail">
                      </div>
                      <div v-if="index < getEveningProductsForPage(pageIndex - 1).length - 1 || isLastEveningPage(pageIndex - 1)" class="arrow-down"><img src="../../../../images/pdf-down-arrow.png" alt="Down arrow"></div>
                    </div>
                  </draggable>

                  <div 
                    v-if="isLastEveningPage(pageIndex - 1)"
                    v-for="n in Math.max(1, 3 - getEveningProductsForPage(pageIndex - 1).length)"
                    :key="'evening-empty-' + n"
                    class="drop-zone-wrapper"
                  >
                    <div 
                      class="drop-zone"
                      @drop="onDropEvening($event)"
                      @dragover.prevent
                      @dragenter.prevent
                    >
                      + Drag product here to add
                    </div>
                    <div v-if="n < Math.max(1, 3 - getEveningProductsForPage(pageIndex - 1).length)" class="arrow-down"><img src="../../../../images/pdf-down-arrow.png" alt="Down arrow"></div>
                  </div>

                  <!-- Additional info (only on last page) -->
                  <template v-if="isLastEveningPage(pageIndex - 1)">
                    <div v-if="!eveningAdditionalInfo" class="additional-info-section">
                      <a class="add-info-link" href="#" @click.prevent="openAdditionalInfoModal('evening')">Add Additional information</a>
                    </div>
                    <div v-else class="additional-info-section">
                      <div class="additional-info-title">
                        <p>Additional Information</p>
                        <a class="edit-info-link" href="#" @click.prevent="openAdditionalInfoModal('evening')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.75C9 15.3358 9.33577 15 9.75 15H15.75C16.1642 15 16.5 15.3358 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H9.75C9.33577 16.5 9 16.1642 9 15.75Z" fill="#323232"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5802 6.07495C16.7875 4.86286 16.7362 3.27114 15.8347 2.29637C15.3951 1.82107 14.7694 1.51747 14.0608 1.50073C13.3495 1.48393 12.6125 1.75595 11.9325 2.32489C11.9151 2.33944 11.8984 2.35477 11.8824 2.37083L2.15584 12.1362C1.73582 12.5578 1.5 13.1288 1.5 13.724V14.9941C1.5 15.8203 2.16898 16.5 3.00287 16.5H4.26199C4.86028 16.5 5.43393 16.2617 5.85614 15.8378L15.5802 6.07495ZM12.9053 4.34471C12.6124 4.05182 12.1375 4.05182 11.8447 4.34471C11.5518 4.63761 11.5518 5.11248 11.8447 5.40538L12.5947 6.15537C12.8875 6.44826 13.3624 6.44826 13.6553 6.15537C13.9482 5.86248 13.9482 5.38761 13.6553 5.09471L12.9053 4.34471Z" fill="#323232"/>
                        </svg>
                      </a>
                      </div>
                      <p class="additional-info-text">{{ eveningAdditionalInfo }}</p>
                    </div>

                    <!-- As Needed section -->
                    <div class="as-needed-divider"></div>
                    <div class="as-needed-label">As Needed</div>
                    
                    <draggable 
                      v-model="eveningAsNeeded" 
                      :options="dragOptions"
                      @change="handleDragChange($event, 'evening-as-needed')"
                      @start="onDragStart($event, 'evening-as-needed')"
                      @end="onDragEnd($event)"
                      class="draggable-container"
                      data-section="evening-as-needed"
                      :move="checkMove"
                    >
                      <div 
                        v-for="(product, index) in eveningAsNeeded" 
                        :key="product.variant_graph_id || index"
                        class="drop-zone-wrapper"
                        :class="{ 'dragging-to-remove': isDraggingOutside && draggedProduct === product }"
                      >
                        <div class="drop-zone with-product d-flex justify-content-between">
                          <span class="product-number">{{ index + 1 }}</span>
                          <div class="product-name d-flex flex-column text-left">
                            <!-- Rx Badge for prescription products -->
                            <div v-if="product.handle === 'rx'" class="rx-badge">
                              <span class="rx-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                        <path d="M7.45728 9.74983L8.85377 8.3534C8.94744 8.25961 9.00004 8.13247 9 7.99992C8.99996 7.86737 8.94728 7.74027 8.85355 7.64654C8.75982 7.55281 8.63271 7.50014 8.50015 7.5001C8.3676 7.50006 8.24045 7.55265 8.14666 7.64632L6.75017 9.04275L4.14305 6.43575C4.93316 6.27628 5.63583 5.82892 6.11463 5.18052C6.59343 4.53212 6.8142 3.72894 6.73407 2.92693C6.65395 2.12491 6.27865 1.38127 5.68103 0.840402C5.08342 0.299531 4.30614 1.27586e-05 3.50009 0H0.500013C0.367402 1.32604e-06 0.240222 0.0526793 0.146452 0.146446C0.0526816 0.240212 1.32609e-06 0.367386 0 0.499991V9.99982C0 10.1324 0.0526799 10.2596 0.14645 10.3534C0.240221 10.4471 0.367401 10.4998 0.500013 10.4998C0.632625 10.4998 0.759805 10.4471 0.853575 10.3534C0.947346 10.2596 1.00003 10.1324 1.00003 9.99982V6.49989H2.79298L6.04306 9.74983L4.64657 11.1463C4.6001 11.1927 4.56322 11.2478 4.53805 11.3085C4.51289 11.3691 4.49992 11.4342 4.4999 11.4999C4.49988 11.5655 4.51281 11.6306 4.53793 11.6913C4.56306 11.752 4.5999 11.8071 4.64635 11.8536C4.6928 11.9 4.74794 11.9368 4.80864 11.962C4.86933 11.9871 4.93438 12 5.00006 12C5.06575 12 5.13079 11.987 5.19147 11.9619C5.25214 11.9367 5.30726 11.8998 5.35368 11.8533L6.75017 10.4569L8.14666 11.8533C8.24045 11.947 8.3676 11.9996 8.50015 11.9996C8.63271 11.9995 8.75982 11.9468 8.85355 11.8531C8.94728 11.7594 8.99996 11.6323 9 11.4997C9.00004 11.3672 8.94744 11.24 8.85377 11.1463L7.45728 9.74983ZM1.00003 5.4999V0.999982H3.50009C4.09684 0.999982 4.66915 1.23703 5.09112 1.65898C5.51309 2.08093 5.75015 2.65322 5.75015 3.24994C5.75015 3.84667 5.51309 4.41896 5.09112 4.8409C4.66915 5.26285 4.09684 5.4999 3.50009 5.4999H1.00003Z" fill="black"/>
                      </svg>
                    </span>
                              <span>Prescription</span>
                            </div>
                            <!-- Regular product display -->
                            <template v-else>
                              <p>{{ product.title }}</p>
                              <span>{{ product.vendor }}</span>
                            </template>
                            <a href="#" @click.prevent="removeProduct(product, 'evening-as-needed')">Remove</a>
                          </div>
                          <img :src="product.image" alt="product thumbnail" class="product-thumbnail">
                        </div>
                        <div class="arrow-down"><img src="../../../../images/pdf-down-arrow.png" alt="Down arrow"></div>
                      </div>
                    </draggable>

                    <!-- Always show one empty drop zone for adding more products -->
                    <div class="drop-zone-wrapper">
                      <div 
                        class="drop-zone"
                        @drop="onDropEveningAsNeeded($event)"
                        @dragover.prevent
                        @dragenter.prevent
                      >
                        + Drag as needed product here
                      </div>
                    </div>
                  </template>
                </div>

              </div><!-- /regimen-columns -->
            </div>

            
          </div>
        </div>
      </div>
      
      <!-- Sticky Footer -->
      <div class="sticky-footer">
        <div class="footer-left">
          <div class="footer-info">
            <p class="footer-title">Regimen Name</p>
            <span class="footer-subtitle">{{ totalProductsCount }} Products</span>
          </div>
          
          <div v-if="totalPrice > 0" class="footer-price">
            <span class="price-label">Total Price:</span>
            <strong class="price-value">${{ totalPrice.toFixed(2) }}</strong>
          </div>
        </div>
        
        <div class="footer-actions">
          <button
            type="button"
            class="btn_custom btn_line"
            @click="leaveWithoutSaving"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn_custom btn_line"
            :disabled="loading || totalProductsCount === 0"
            @click="completeRegimen('save')"
          >
            {{ loading && loadingAction === 'save' ? 'Saving...' : 'Save' }}
          </button>
          <button
            type="button"
            class="btn_custom btn_line"
            :disabled="loading || totalProductsCount === 0"
            @click="completeRegimen('preview')"
          >
            {{ loading && loadingAction === 'preview' ? 'Saving...' : 'Preview PDF' }}
          </button>
          <button
            type="button"
            class="btn_custom btn_prime"
            :disabled="loading || totalProductsCount === 0"
            @click="completeRegimen('email_regimen')"
          >
            {{ loading && loadingAction === 'email_regimen' ? 'Saving...' : 'Email Regimen' }}
          </button>
        </div>
      </div>
    </div>
    
    <!-- Additional Information Modal -->
    <div v-if="showAdditionalInfoModal" class="modal-overlay" @click.self="closeAdditionalInfoModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Add Additional Information</h3>
          <button class="close-btn" @click="closeAdditionalInfoModal">×</button>
        </div>
        <div class="modal-body">
          <textarea
            v-model="tempAdditionalInfo"
            placeholder="Start typing...."
            rows="6"
            maxlength="2203"
            class="additional-info-textarea"
          />
        </div>
        <div class="modal-footer">
          <button class="btn_custom btn_line" @click="closeAdditionalInfoModal">
            Cancel
          </button>
          <button class="btn_custom btn_prime" @click="saveAdditionalInfo">
            Add Information
          </button>
        </div>
      </div>
    </div>
  </div>
</template> 

<style>
  body.regimen-editor-active{
    overflow-y: hidden;
  }
  .partition {
    display: flex;
    min-height: 100%;
  }

  .partition-left {
    width: 50%;
    flex-shrink: 0;
    border-right: 1px solid #E4E4E4;
    background: #F7F7F7;
    padding: 2rem 0;
    position: relative;
    overflow-y: scroll;
    height: calc(100vh - 200px);
  }
  .section-top{
    padding: 0 24px;
  }

  .partition-right {
    flex: 1;
    padding: 32px 24px 0;
    overflow-y: auto;
    height: calc(100vh - 200px);
  }

  /* ── PANEL TITLE ─────────────────────────────── */
  .panel-title {
    font-size: 25px;
    font-weight: 800;
    color: #1a1a2e;
    margin-bottom: 16px;
  }

  /* ── SEARCH BAR ──────────────────────────────── */
  .search-bar {
    display: flex;
    align-items: center;
    gap: .6rem;
    border: 1px solid #E4E4E4;
    border-radius: 12px;
    padding: 0 0 0 1rem;
    background: #fff;
    margin-bottom: 24px;
    transition: border-color .18s;
  }
  .search-bar:focus-within {
    border-color: #9F7ED9;
  }
  .search-bar input[type="text"] {
    border: none;
    outline: none;
    flex: 1;
    font-size: 16px;
    color: #555;
    background: transparent;
    padding: 10px 20px 10px 0;
  }
  .search-bar input[type="text"]:focus { outline: none; box-shadow: none; border: none; }
  .search-bar input[type="text"]::placeholder { color: #bbb; }

  /* ── FILTERS ─────────────────────────────────── */
  .filters-container {
    margin-bottom: 0;
    border-bottom: 1px solid #E4E4E4;
  }

  .filters-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: .75rem;
  }

  .filters-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: .5rem .6rem;
    margin-bottom: 16px;
  }

  .filter-dropdown {
    width: 100%;
    border-radius: 12px;
  }
  .filter-dropdown select,
  .filter-dropdown .select-trigger,
  .filter-dropdown .vs__dropdown-toggle {
    width: 100%;
    border: 1px solid var(--border) !important;
    border-radius: var(--radius) !important;
    padding: .5rem .85rem !important;
    font-size: .88rem !important;
    color: #444 !important;
    background-color: #fff !important;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 16 16'%3E%3Cpath fill='%23888' d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E") !important;
    background-repeat: no-repeat !important;
    background-position: right .8rem center !important;
    box-shadow: none !important;
    transition: border-color .18s;
  }
  .filter-dropdown select:focus,
  .filter-dropdown .vs__dropdown-toggle:focus-within {
    border-color: var(--accent) !important;
    outline: none;
  }

  .patient-change-regimen-new .form-filter {
    background-color: white;
    border: solid 1px #dbdadb;
    border-radius: 12px;
    padding-left: 1em;
    padding-top: 0.1em;
    margin-bottom: 15px;
  }
  .patient-change-regimen-new .form-filter .form1-items{
    margin: 1em 0;
  }

  /* ── SEARCH STATUS & ACTIVE FILTERS ─────────── */
  .search-status-section {
    padding: 12px 24px;
    background: #F7F7F7;
    border-bottom: 1px solid #E4E4E4;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .search-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 6px;
    width: fit-content;
  }

  .search-indicator.searching {
    color: #6366f1;
    background: #eef2ff;
  }

  .search-indicator.completed {
    color: #059669;
    background: #d1fae5;
  }

  .search-indicator svg {
    flex-shrink: 0;
  }

  .spinner {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .active-filters {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .filter-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }

  .filter-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px 4px 10px;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 13px;
    color: #374151;
    cursor: pointer;
    transition: all 0.15s;
    font-weight: 500;
  }

  .filter-tag:hover {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #dc2626;
  }

  .filter-tag:hover .filter-tag-close {
    color: #dc2626;
  }

  .filter-tag-label {
    line-height: 1;
  }

  .filter-tag-close {
    color: #6b7280;
    transition: color 0.15s;
    flex-shrink: 0;
  }

  .clear-all-filters {
    padding: 4px 10px;
    background: transparent;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 13px;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.15s;
    font-weight: 500;
    line-height: 1;
  }

  .clear-all-filters:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
    color: #374151;
  }

  /* ── DRAGGABLE ──────────────────────────────── */
  .product-wrapper {
    cursor: move;
    cursor: grab;
  }
  
  .product-wrapper:active {
    cursor: grabbing;
    opacity: 0.7;
  }
  
  .draggable-container {
    min-height: 10px;
  }
  
  .drop-zone-wrapper {
    margin-bottom: 0;
  }
  
  .rx-badge {
    cursor: grab;
  }
  
  .rx-badge:active {
    cursor: grabbing;
    opacity: 0.8;
  }
  
  .ghost {
    opacity: 0.5;
    background: #f5f0fd;
  }
  
  .dragging-to-remove .drop-zone {
    background: #f0f0f0 !important;
    border-color: #9ca3af !important;
    opacity: 0.6;
    transition: background 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
  }

  /* ── PRESCRIPTION SECTION ──────────────────── */
  .prescription-section {
    padding: 16px 24px;
    border-bottom: 1px solid #E4E4E4;
    margin-bottom: 16px;
  }

  .prescription-title {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 .2rem;
  }

  .prescription-sub {
    font-size: 14px;
    color: #6b7280;
    margin: 0 0 6px;
  }

  .prescription-row {
    display: flex;
    align-items: center;
    gap: .55rem;
    flex-wrap: wrap;
  }

  .rx-badge {
    display: inline-flex;
    align-items: center;
    gap: .35rem;
    background: #DFC5FE;
    color: #000000;
    font-size: 14px;
    font-weight: 500;
    padding: .4rem .9rem;
    border-radius: 999px;
    user-select: none;
    flex-shrink: 0;
  }

  .rx-icon {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
  }

  /* Counter circle */
  .rx-counter {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e5e7eb;
    color: #6b7280;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    flex-shrink: 0;
  }

  /* ── PRODUCTS SECTION ────────────────────────── */
  .products-section { 
    margin-top: 0; 
    padding: 0 10px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 1rem;
    padding: 0 17px;
  }

  .loading-state,
  .no-products {
    text-align: center;
    color: #222222;
    padding: 2rem 0;
    font-size: 16px;
  }

  /* ── PRODUCT LIST ────────────────────────────── */
  .products-list {
    padding: 0 16px 0 17px;
  }

  .product-wrapper {
    border: 1px solid #EBEBEB;
    margin: 0 0 5px 0;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
    transition: box-shadow .18s, border-color .18s;
  }
  .product-wrapper:hover {
    border-color: #9F7ED9;
    box-shadow: 0 4px 18px rgba(159, 126, 217, .13);
  }

  .product-item {
    display: flex;
    align-items: center;
    gap: .75rem;
    padding: 10px 20px;
    cursor: grab;
  }
  .product-item:active { cursor: grabbing; }

  .product-info-wrapper {
    display: flex;
    align-items: center;
    gap: .85rem;
    flex: 1;
    min-width: 0;
  }

  .patient-change-regimen-new .product-image {
    width: 40px;
    height: 40px;
    border: 1px solid #F2F2F2;
    object-fit: contain;
    flex-shrink: 0;
    border-radius: 6px;
    background: #f3f3f9;
  }

  .patient-change-regimen-new .product-details {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .product-name {
    font-size: 16px;
    font-weight: 400;
    color: #6b7280;
    margin: 0 0 3px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .product-vendor {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .product-type  { display: none; }
  .product-price { display: none; }

  .patient-change-regimen-new .product-actions {
    display: flex;
    align-items: center;
    gap: 32px;
    flex-shrink: 0;
  }

  .patient-change-regimen-new .product-actions a.btn-view {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
    transition: color .15s;
  }
  .btn-view:hover { color: #9F7ED9; }

  .btn_prime {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    background: #6c63b6;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background .18s, opacity .18s;
    flex-shrink: 0;
  }
  .btn_prime:hover { background: #5a52a3; }
  .btn_prime:disabled {
    background: #e5e7eb;
    cursor: not-allowed;
    opacity: 0.6;
    color: #9ca3af;
  }
  .btn_prime.btn_added {
    background: #86efac;
    cursor: not-allowed;
    opacity: 1;
  }
  .btn_prime svg { display: block; }

  /* ── TIME BUTTONS ──────────────────────────── */
  .product-item .time-btn {
    background: #F9F9F9;
  }
  
  .time-btn {
    width: 80px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    background: #fff;
    border: 1px solid #E4E4E4;
    border-radius: 8px;
    padding: 4px 12px;
    cursor: pointer;
    color: #374151;
    transition: border-color .15s, color .15s, background .15s;
    line-height: 1;
    white-space: nowrap;
  }
  .time-btn:hover {
    border-color: #9F7ED9;
    color: #9F7ED9;
    background: #f5f0fd;
  }
  .time-btn.disabled,
  .time-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
    background: #f5f5f5;
  }
  .time-btn--both {
    padding: .38rem .55rem;
  }

  .time-actions {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  /* ── EXPANDABLE DESCRIPTION ──────────────────── */
  .product-description {
    border-top: 1px solid var(--border);
    padding: .75rem 1rem;
    background: #fafafa;
  }
  .description-content h5 {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: .4rem;
    color: #333;
  }
  .description-text {
    font-size: .83rem;
    color: #000000;
    line-height: 1.5;
  }
  .no-description {
    font-size: .83rem;
    color: #222222;
    margin: 0;
  }

  /* ── PAGINATION ──────────────────────────────── */
  .pagination-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
    padding-top: .75rem;
    border-top: 1px solid var(--border);
    flex-wrap: wrap;
    gap: .5rem;
  }

  .page-results {
    display: flex;
    align-items: center;
    gap: .4rem;
    font-size: 12px;
    color: #000000;
  }
  .page-results select {
    border: 1px solid var(--border);
    border-radius: 6px;
    padding: .2rem .4rem;
    font-size: 12px;
    cursor: pointer;
    color: #444;
  }
  .page-results select:focus { outline: none; border-color: var(--accent); }

  .pagination-r .pagination {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: .3rem;
  }
  .pagination-r .pagination li a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid var(--border);
    border-radius: 7px;
    color: #000000;
    text-decoration: none;
    font-size: 16px;
    transition: border-color .15s, color .15s;
  }
  .pagination-r .pagination li a:hover:not(.disabled) {
    border-color: var(--accent);
    color: var(--accent);
  }
  .pagination-r .pagination li a.disabled {
    opacity: .4;
    cursor: not-allowed;
    pointer-events: none;
  }

  /* ── SCROLLBARS ──────────────────────────────── */
  .partition-left::-webkit-scrollbar,
  .partition-right::-webkit-scrollbar     { width: 10px; }

  .partition-left::-webkit-scrollbar-track,
  .partition-right::-webkit-scrollbar-track { background: #FFFFFF; }

  .partition-left::-webkit-scrollbar-thumb,
  .partition-right::-webkit-scrollbar-thumb {
    background: #9F7ED9;
    border-radius: 8px;
    border: 2px dashed transparent;
    background-clip: padding-box;
  }

  /* ═══════════════════════════════════════════════
    RIGHT PANEL — REGIMEN
  ═══════════════════════════════════════════════ */

  .regimen-header { margin-bottom: 1.25rem; }

  .regimen-title {
    font-size: 25px;
    font-weight: 700;
    color: #000000;
    margin-bottom: 16px;
  }

  .regimen-subtitle {
    font-family: 'manrope', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #222222;
    margin: 0;
  }

  .regimen-preview-block {
    display: flex;
    width: 100%;
    border: 1px solid #F4F4F4;
    flex-direction: column;
    margin-bottom: 24px;
  }

  .regimen-brand {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #F4F4F4;
  }
  .client-details{
    font-size: 12px;
  }

  .brand-avatar {
    width: 30px;
    height: 30px;
    background: var(--accent);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: .72rem;
    flex-shrink: 0;
  }

  .brand-name {
    width: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .brand-name img:first-child {
    padding-right: 5px;
    border-right:1px solid #E0E0E0;
  }
  .brand-name img.no-border:first-child {
    border-right: none !important;
  }
  .brand-name img:last-child {
    padding-left: 5px;
  }


  /* ── REGIMEN COLUMNS ─────────────────────────── */
  .regimen-columns {
    display: grid;
    grid-template-columns: 2fr 2fr;
    height: 100%;
  }

  .regimen-col-title {
    position: relative;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 1;
    padding-bottom: 6px;
    margin-bottom: 17px;
    color: #1a1a2e;
  }
  .regimen-col-title:after {
    content: "";
    background: #9F7ED9;
    width: 44px;
    height: 2px;
    position: absolute;
    left: 50%;
    top: 18px;
    transform: translate(-50%, 50%);
  }

  .regimen-col-evening,
  .regimen-col-morning {
    padding: 16px 13px;
  }

  /* Product cards with numbers */
  .with-product {
    position: relative;
    padding-left: 28px; /* room for the number */
  }

  /* Number renders inside top-left of the card */
  .product-number {
    position: absolute;
    left: -6px;
    top: -6px;
    font-size: 8px;
    font-weight: 700;
    color: #000000;
    line-height: 1;
    width: 17px;
    height: 17px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px solid #F2F2F2;
  }

  .regimen-col-evening { background: #F1ECF9; }

  .drop-zone {
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    min-height: 63px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    font-weight: 700;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    color: #000000;
    background: #fff;
    cursor: pointer;
    padding: 8px 12px;
    transition: border-color .18s, background .18s, color .18s;
    box-shadow: 0px 4px 4px 0px #9F7ED952;
  }
  .drop-zone:hover { border: 1px dashed #DFC5FE; }
  .product-name{
    gap: 4px;
  }
  .drop-zone.with-product{
    position: relative;
  }
  .drop-zone.with-product img {
    width: 47px;
    height: 47px;
    border: 1px solid #9F7ED9;
    border-radius: 12px;
    object-fit: contain;
    background: #ffffff;
  }
  .drop-zone .product-name p { 
    font-weight: 500;
    font-size: 11px;
    line-height: 1;
    margin: 0;
    color: #000000;
   }
  .drop-zone .product-name span{
    font-weight: 700;
    font-size: 9px;
    line-height: 1;
    color: #000000;
   }
  .drop-zone .product-name a{
    font-weight: 700;
    font-size: 10px;
    line-height: normal;
    text-decoration: underline;
    color: #000000;
    margin-top: 2px;
    width: fit-content;
   }
  .arrow-down {
    display: flex;
    justify-content: center;
    margin: .35rem 0;
  }
  .arrow-down img {
    width: 21px;
    height: 21px;
  }

  .as-needed-divider {
    height: 1px;
    background: #E0E0E0;
    margin: 1rem 0 0.5rem;
  }

  .as-needed-label {
    text-align: center;
    font-size: 12px;
    color: #000000;
    font-weight: 500;
    margin: .8rem 0 .4rem;
  }

  .add-info-link {
    display: block;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    text-decoration: underline;
    color: #444;
    margin-top: .8rem;
    cursor: pointer;
  }
  .add-info-link:hover { color: var(--accent); }
  
  .additional-info-section{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-direction: column;
    margin-top: 20px;
    font-size: 10px;
    text-align: justify;
  }
  .additional-info-section .additional-info-title{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    margin-bottom: 12px;
  }
  .additional-info-section .additional-info-title p{
    width: 100%;
    text-align: center;
    padding-left: 22px;
    margin-bottom: 0;
  } 
  
  /* ── MODAL STYLES ──────────────────────────────── */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .modal-overlay .modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 650px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    padding: 24px;
  }
  
  .modal-overlay .modal-content .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    border-bottom: 0px solid;
    padding: 0;
  }
  
  .modal-header h3 {
    font-size: 16px;
    font-weight: 400;
    color: #111827;
    margin: 0;
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 28px;
    color: #6B7280;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  .close-btn:hover { color: #111827; }
  
  .modal-content .modal-body {
    padding: 12px 0;
  }
  
  .additional-info-textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #e0e0e0;
    background-color: #F9F9F9;
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;
    min-height: 120px;
  }
  .additional-info-textarea:focus {
    outline: none;
    border-color: #9F7ED9;
    box-shadow: 0 0 0 3px rgba(159, 126, 217, 0.1);
  }
  
  .modal-content .modal-footer {
    padding: 0;
    border-top: 0px solid;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .modal-content .modal-footer .btn_custom.btn_prime{
    width: 273px;
    height: 44px;
    min-width: 273px;
  }
  .modal-content .modal-footer .btn_custom.btn_line{
    height: 44px;
    color: #2C3146;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .footer-actions .btn_custom.btn_prime{
    width: 273px;
    height: auto;
    min-width: 273px;
  }
  .footer-actions .btn_custom.btn_prime:disabled {
    background: #e5e7eb;
    cursor: not-allowed;
    opacity: 0.6;
    color: #9ca3af;
  }

  /* ── RESPONSIVE ──────────────────────────────── */
  @media (max-width: 991px) {
    .partition { flex-direction: column; }
    .partition-left {
      width: 100%;
      max-width: 100%;
      border-right: none;
      border-bottom: 1px solid var(--border);
    }
    .partition-right { padding: 1.5rem 1rem; }
  }

  @media (max-width: 767px) {
    .filters-grid { grid-template-columns: 1fr; }
    .product-price { display: none; }
    .product-type  { display: none; }
  }

  @media (max-width: 575px) {
    .regimen-columns { grid-template-columns: 1fr; }
    .partition-left,
    .partition-right { padding: 1rem; }
    .panel-title   { font-size: 25px; }
    .regimen-title { font-size: 1.4rem; }
    .product-item  { gap: .5rem; padding: .6rem .75rem; }
  }
</style>

<script>
import logo from '@images/logo-light.png';
import draggable from 'vuedraggable';
import productList from '@/mixins/productList';
import FilterSelect from '@/views/dashboard/partials/FilterSelect';
import { RegimenService } from '@/services/api.service';
import { SEND_REGIMEN, UPDATE_PATIENT } from '@/store/patients/actions.types';
import PresetRegimenNew from '../partials/PresetRegimenNew';
import { tags } from '@/store/regimen/initialObject';
import store from '@/store';

// @group Patinet
// Component to change patient regimen new
export default {
  name: 'PatientChangeRegimenNew',
  components: {
    draggable,
    FilterSelect,
    PresetRegimenNew
  },

  mixins: [productList],
  props: {
    // @vuese
    // Patient object
    patient: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      patientId: null,
      regimenId: null,
      logo,
      loading: false,
      loadingAction: null,
      expandedProduct: null,
      morningProducts: [],
      eveningProducts: [],
      morningAsNeeded: [],
      eveningAsNeeded: [],
      showAdditionalInfoModal: false,
      currentSection: null, // 'morning' or 'evening'
      morningAdditionalInfo: '',
      eveningAdditionalInfo: '',
      tempAdditionalInfo: '',
      dragOptions: {
        animation: 200,
        group: 'products',
        disabled: false,
        ghostClass: 'ghost'
      },
      isDraggingOutside: false,
      draggedProduct: null,
      draggedSection: null,
      duplicateRejectedProduct: null,
      isSearching: false,
      searchCompleted: false,
      searchCompletedTimeout: null,
      productsType: 'topPicks',
      creators: '',
      concernSelected: '',
      regimenTags: tags,
    };
  },
  computed: {
    // Get active filters for display
    activeFilters() {
      const filters = [];
      if (this.brand) filters.push({ type: 'brand', label: this.brand, value: this.brand });
      if (this.concern) filters.push({ type: 'concern', label: this.concern, value: this.concern });
      if (this.category) filters.push({ type: 'category', label: this.category, value: this.category });
      if (this.ingredient) filters.push({ type: 'ingredient', label: this.ingredient, value: this.ingredient });
      if (this.search) filters.push({ type: 'search', label: `Search: "${this.search}"`, value: this.search });
      return filters;
    },
    totalProductsCount() {
      return this.morningProducts.length + 
             this.eveningProducts.length +
             this.morningAsNeeded.length + 
             this.eveningAsNeeded.length;
    },
    totalPrice() {
      // Use a Map to track unique products and count each only once
      const uniqueProducts = new Map();
      
      // Add all products from all sections
      [...this.morningProducts, ...this.eveningProducts, ...this.morningAsNeeded, ...this.eveningAsNeeded].forEach(product => {
        // Use variant_graph_id or shopify_product_graph_id as unique identifier
        const key = product.variant_graph_id || product.shopify_product_graph_id || product.id;
        if (key && !uniqueProducts.has(key)) {
          uniqueProducts.set(key, parseFloat(product.price || 0));
        }
      });
      
      // Sum up prices of unique products
      let total = 0;
      uniqueProducts.forEach(price => {
        total += price;
      });
      
      return total;
    },
    // Calculate total number of pages needed
    totalPages() {
      const morningPages = Math.ceil(this.morningProducts.length / 8) || 1;
      const eveningPages = Math.ceil(this.eveningProducts.length / 8) || 1;
      return Math.max(morningPages, eveningPages);
    },
    // Calculate morning pages
    morningPages() {
      return Math.ceil(this.morningProducts.length / 8) || 1;
    },
    // Calculate evening pages
    eveningPages() {
      return Math.ceil(this.eveningProducts.length / 8) || 1;
    },
    // Get morning products for a specific page
    getMorningProductsForPage() {
      return (pageIndex) => {
        const start = pageIndex * 8;
        const end = start + 8;
        return this.morningProducts.slice(start, end);
      };
    },
    // Get evening products for a specific page
    getEveningProductsForPage() {
      return (pageIndex) => {
        const start = pageIndex * 8;
        const end = start + 8;
        return this.eveningProducts.slice(start, end);
      };
    },
    // Check if this is the last page
    isLastPage() {
      return (pageIndex) => pageIndex === this.totalPages - 1;
    },
    // Check if this is the last morning page
    isLastMorningPage() {
      return (pageIndex) => pageIndex === this.morningPages - 1;
    },
    // Check if this is the last evening page
    isLastEveningPage() {
      return (pageIndex) => pageIndex === this.eveningPages - 1;
    },
    // Check if a product is in morning regimen
    isProductInMorning() {
      return (product) => {
        const id = product.id || product.shopify_product_graph_id;
        return this.morningProducts.some(p =>
          (id && p.shopify_product_graph_id === id) ||
          (product.variants && product.variants[0] && p.variant_graph_id === product.variants[0].id)
        );
      };
    },
    // Check if a product is in evening regimen
    isProductInEvening() {
      return (product) => {
        const id = product.id || product.shopify_product_graph_id;
        return this.eveningProducts.some(p =>
          (id && p.shopify_product_graph_id === id) ||
          (product.variants && product.variants[0] && p.variant_graph_id === product.variants[0].id)
        );
      };
    },
    // Check if a product is in as needed
    isProductInMorningAsNeeded() {
      return (product) => {
        const id = product.id || product.shopify_product_graph_id;
        return this.morningAsNeeded.some(p =>
          (id && p.shopify_product_graph_id === id) ||
          (product.variants && product.variants[0] && p.variant_graph_id === product.variants[0].id)
        );
      };
    },
    isProductInEveningAsNeeded() {
      return (product) => {
        const id = product.id || product.shopify_product_graph_id;
        return this.eveningAsNeeded.some(p =>
          (id && p.shopify_product_graph_id === id) ||
          (product.variants && product.variants[0] && p.variant_graph_id === product.variants[0].id)
        );
      };
    },
    // Check if product should be hidden from list
    shouldHideProduct() {
      return (product) => {
        const inMorning = this.isProductInMorning(product);
        const inEvening = this.isProductInEvening(product);

        // Hide only when product already exists in both morning and evening
        return (
          (inMorning) &&
          (inEvening)
        );
      };
    },
    // Filtered products for display
    filteredProducts() {
      return this.products.filter(product => {
        // Filter out Gift Cards
        if (product.productType === 'Gift Cards') {
          return false;
        }
        // Filter out products already added
        return !this.shouldHideProduct(product);
      });
    }
  },
  watch: {
      // Automatically fetch next page when all products are added
      filteredProducts(newVal) {
        // If all products are added (filteredProducts is empty), more products exist, and not currently loading
        if (Array.isArray(newVal) && newVal.length === 0 && this.hasNextPage && !this.sending) {
          this.getMoreProducts();
        }
      },
    patient: {
      handler: 'fillData',
      immediate: true
    }
  },
  mounted() {
    // Add body class to prevent scrolling
    document.body.classList.add('regimen-editor-active');
    
    // Initialize filters and products
    const practiceId = this.patient?.practice?.id || this.practice?.id;
    if (practiceId) {
      this.getFilters({practice: practiceId});
    } else {
      this.getFilters();
    }
    
    // Load products
    this.fetchData();
  },
  beforeDestroy() {
    // Remove body class when leaving component
    document.body.classList.remove('regimen-editor-active');
    
    // Clean up timeouts
    if (this.searchCompletedTimeout) {
      clearTimeout(this.searchCompletedTimeout);
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  methods: {
    // @vuese
    // Used to redirect to Patient view page
    leaveWithoutSaving() {
      this.$router.push({name: 'PatientView', params: {id: this.patientId}});
    },
    
    // @vuese
    // Used to fill patient data in local store
    fillData() {
      this.patientId = this.$route.params.id;
      const { regimen } = this.patient;
      
      if (regimen) {
        this.regimenId = regimen.id;
        console.log('Regimen ID set:', this.regimenId);
        // Load existing regimen products after setting regimenId
        this.loadRegimenProducts();
      }
    },
    
    // @vuese
    // Load existing regimen products from API
    async loadRegimenProducts() {
      if (!this.regimenId) {
        console.log('loadRegimenProducts: No regimen ID');
        return;
      }
      
      console.log('Loading regimen products for regimen ID:', this.regimenId);
      
      try {
        const practiceParam = this.getRequestPracticeId();
        console.log('Practice param:', practiceParam);
        const response = await RegimenService.getRegimenProducts(this.regimenId, practiceParam);
        const data = response.data;
        
        console.log('Regimen products loaded:', data);
        
        // Helper function to transform prescription badge products
        const transformProduct = (product) => {
          if (product.item_type === 'prescription_badge') {
            // Transform prescription badge to Rx format
            return {
              ...product,
              handle: 'rx',
              name: 'Rx',
              title: 'Rx',
              brand: '',
              vendor: '',
              image: require('@images/rx.png'),
              price: 0,
              // Keep the shopify_product_graph_id from API for identification
              shopify_product_graph_id: product.shopify_product_graph_id || `rx-${product.id}`,
              variant_graph_id: product.variant_graph_id || `rx-variant-${product.id}`
            };
          }
          return product;
        };
        
        // Load morning products
        if (data.morning && data.morning.products) {
          this.morningProducts = data.morning.products.map(transformProduct);
        }
        
        // Load evening products
        if (data.evening && data.evening.products) {
          this.eveningProducts = data.evening.products.map(transformProduct);
        }
        
        // Load as needed products (single shared list)
        if (data.morning_as_needed && data.morning_as_needed.products) {
          this.morningAsNeeded = data.morning_as_needed.products.map(transformProduct);
        }

        if (data.evening_as_needed && data.evening_as_needed.products) {
          this.eveningAsNeeded = data.evening_as_needed.products.map(transformProduct);
        }
        
        // Load instructions
        if (data.morning_instructions) {
          this.morningAdditionalInfo = data.morning_instructions;
        }
        if (data.evening_instructions) {
          this.eveningAdditionalInfo = data.evening_instructions;
        }
        this.lastEditedAt = data.last_edited_at;
        this.lastEditedBy = data.last_edited_by;
      } catch (error) {
        console.error('Failed to load regimen products:', error);
      }
    },
    
    // @vuese
    // Start dragging a product
    startDragProduct(event, product) {
      event.dataTransfer.effectAllowed = 'copy';
      event.dataTransfer.setData('product', JSON.stringify(product));
      event.dataTransfer.setData('type', 'product');
      
      // Create custom drag image
      const dragImage = document.createElement('div');
      dragImage.style.cssText = `
        position: absolute;
        top: -1000px;
        left: -1000px;
        background: white;
        border: 2px solid #9F7ED9;
        border-radius: 12px;
        padding: 16px 20px;
        box-shadow: 0 4px 12px rgba(159, 126, 217, 0.3);
        width: 660px;
        min-width: 660px;
        z-index: 10000;
      `;
      dragImage.innerHTML = `
        <div style="font-size: 14px; font-weight: 700; color: #111827; margin-bottom: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${product.title}</div>
        <div style="font-size: 12px; color: #6b7280; white-space: nowrap;">Let go to drop in position</div>
      `;
      document.body.appendChild(dragImage);
      event.dataTransfer.setDragImage(dragImage, 330, 30);
      
      // Remove drag image after drag ends
      setTimeout(() => {
        document.body.removeChild(dragImage);
      }, 0);
    },
    
    // @vuese
    // Start dragging RX badge
    startDragRx(event) {
      event.dataTransfer.effectAllowed = 'copy';
      event.dataTransfer.setData('type', 'rx');
      
      // Create custom drag image that matches the original rx-badge
      const dragImage = document.createElement('div');
      dragImage.style.cssText = `
        position: absolute;
        top: -1000px;
        left: -1000px;
        display: inline-flex;
        align-items: center;
        gap: .35rem;
        background: #DFC5FE;
        color: #000000;
        font-size: 14px;
        font-weight: 500;
        padding: .4rem .9rem;
        border-radius: 999px;
        user-select: none;
        z-index: 10000;
      `;
      dragImage.innerHTML = `
        <span style="font-size: 1rem; font-weight: 700; line-height: 1;">℞</span>
        <span>Prescription</span>
      `;
      document.body.appendChild(dragImage);
      event.dataTransfer.setDragImage(dragImage, 20, 20);
      
      // Remove drag image after drag ends
      setTimeout(() => {
        document.body.removeChild(dragImage);
      }, 0);
    },
    
    // @vuese
    // Handle drop in morning section
    onDropMorning(event) {
      event.preventDefault();
      const type = event.dataTransfer.getData('type');
      
      if (type === 'rx') {
        this.addRxProduct('morning', false);
      } else if (type === 'product') {
        const product = JSON.parse(event.dataTransfer.getData('product'));
        this.addProductToSection(product, 'morning', false);
      }
    },
    
    // @vuese
    // Handle drop in as-needed section
    onDropMorningAsNeeded(event) {
      event.preventDefault();
      
      const type = event.dataTransfer.getData('type');
      
      if (type === 'rx') {
        this.addRxProduct('morning', true);
      } else if (type === 'product') {
        const product = JSON.parse(event.dataTransfer.getData('product'));
        this.addProductToSection(product, 'morning', true);
      }
    },

    onDropEveningAsNeeded(event) {
      event.preventDefault();
      
      const type = event.dataTransfer.getData('type');
      
      if (type === 'rx') {
        this.addRxProduct('evening', true);
      } else if (type === 'product') {
        const product = JSON.parse(event.dataTransfer.getData('product'));
        this.addProductToSection(product, 'evening', true);
      }
    },
    
    // @vuese
    // Handle drop in evening section
    onDropEvening(event) {
      event.preventDefault();
      const type = event.dataTransfer.getData('type');
      
      if (type === 'rx') {
        this.addRxProduct('evening', false);
      } else if (type === 'product') {
        const product = JSON.parse(event.dataTransfer.getData('product'));
        this.addProductToSection(product, 'evening', false);
      }
    },
    
    // @vuese
    // Add RX product to a section
    addRxProduct(timeOfUse, asNeeded, showMessage = true) {
      const uniqueId = Date.now() + Math.random();
      const rxProduct = {
        id: null,
        shopify_product_id: null,
        shopify_product_graph_id: 'rx-' + uniqueId,
        variant_id: null,
        variant_graph_id: 'rx-variant-' + uniqueId,
        discount_variant_id: null,
        handle: 'rx',
        name: 'Rx',
        title: 'Rx',
        variant_title: '',
        brand: '',
        vendor: '',
        sku: '',
        image: require('@images/rx.png'),
        price: 0,
        frequency: "One Time",
        usage_instruction: '',
        recomendation_type: 'core',
        position: 0
      };
      
      if (timeOfUse === 'morning') {
        if (asNeeded) {
          this.morningAsNeeded.push(rxProduct);
          if (showMessage) {
            this.flashSuccess('Prescription badge added to Morning As Needed');
          }
        } else {
          this.morningProducts.push(rxProduct);
          if (showMessage) {
            this.flashSuccess('Prescription badge added to Morning regimen');
          }
        }
      } else {
        if (asNeeded) {
          this.eveningAsNeeded.push(rxProduct);
          if (showMessage) {
            this.flashSuccess('Prescription badge added to Evening As Needed');
          }
        } else {
          this.eveningProducts.push(rxProduct);
          if (showMessage) {
            this.flashSuccess('Prescription badge added to Evening regimen');
          }
        }
      }
    },
    
    // @vuese
    // Add RX product to both morning and evening
    addRxProductToBoth() {
      this.addRxProduct('morning', false, false);
      this.addRxProduct('evening', false, false);
      // Show combined message
      this.flashSuccess('Prescription badge added to Morning and Evening regimen');
    },

    createRegimenProduct(product) {
      const variant = product.variants?.[0];

      const extractNumericId = (id) => {
        if (!id) return null;
        return id.split('/').pop();
      };

      return {
        id: null,
        shopify_product_id: extractNumericId(product.id),
        shopify_product_graph_id: product.id,
        variant_id: extractNumericId(variant?.id),
        variant_graph_id: variant ? variant.id : null,
        discount_variant_id: null,
        handle: product.handle || '',
        name: product.title,
        title: product.title,
        variant_title: variant ? variant.title : '',
        brand: product.vendor,
        vendor: product.vendor,
        sku: variant ? variant.sku : '',
        image: (product.images && product.images.edges && product.images.edges[0] && product.images.edges[0].node && product.images.edges[0].node.url) || (product.images && product.images[0] && product.images[0].url) || '/images/product-placeholder.jpg',
        price: variant ? parseFloat(variant.price.amount) : 0,
        frequency: "One Time",
        usage_instruction: '',
        recomendation_type: 'core',
        productType: product.productType || 'Product',
        selling_plan_id: "",
        sample_sku: '',
        full_size_url: '',
        manufacturer_sku: null,
        position: 0
      };
    },
    
    // @vuese
    // Add product to specific section
    addProductToSection(product, timeOfUse, asNeeded) {
      // Check if product is already in as needed
      const isInMorningAsNeeded = this.morningAsNeeded.some(p => p.shopify_product_graph_id === product.id);
      const isInEveningAsNeeded = this.eveningAsNeeded.some(p => p.shopify_product_graph_id === product.id);
      const isInMorning = this.morningProducts.some(p => p.shopify_product_graph_id === product.id);
      const isInEvening = this.eveningProducts.some(p => p.shopify_product_graph_id === product.id);

      if (asNeeded) {
        if (timeOfUse === 'morning') {
          if (isInMorningAsNeeded) {
            this.flashWarning('Product is already in Morning As Needed regimen');
            return;
          }

          if (isInMorning || isInEvening) {
            this.flashWarning(
              'Product is already in Morning or Evening regimen. Remove it first to add to Morning As Needed.'
            );
            return;
          }
        } else if (timeOfUse === 'evening') {
          if (isInEveningAsNeeded) {
            this.flashWarning('Product is already in Evening As Needed regimen');
            return;
          }

          if (isInMorning || isInEvening) {
            this.flashWarning(
              'Product is already in Morning or Evening regimen. Remove it first to add to Evening As Needed.'
            );
            return;
          }
        }
      } else {
        if (timeOfUse === 'morning') {
          if (isInMorningAsNeeded || isInEveningAsNeeded) {
            this.flashWarning(
              'Product is already in As Needed regimen. Remove it first to add to Main.'
            );
            return;
          }

          if (isInMorning) {
            this.flashWarning('Product is already in Morning regimen');
            return;
          }
        } else if (timeOfUse === 'evening') {
          if (isInMorningAsNeeded || isInEveningAsNeeded) {
            this.flashWarning(
              'Product is already in As Needed regimen. Remove it first to add to Main.'
            );
            return;
          }

          if (isInEvening) {
            this.flashWarning('Product is already in Evening regimen');
            return;
          }
        }
      }
      
      // Transform Shopify product to regimen product format
      const regimenProduct = this.createRegimenProduct(product);
      
      // Add to appropriate section
      if (asNeeded) {
        if (timeOfUse === 'morning') {
          this.morningAsNeeded.push(regimenProduct);
          this.flashSuccess(`${product.title} added to Morning As Needed`);
        } else {
          this.eveningAsNeeded.push(regimenProduct);
          this.flashSuccess(`${product.title} added to Evening As Needed`);
        }
      } else {
        if (timeOfUse === 'morning') {
          this.morningProducts.push(regimenProduct);
          this.flashSuccess(`${product.title} added to Morning regimen`);
        } else {
          this.eveningProducts.push(regimenProduct);
          this.flashSuccess(`${product.title} added to Evening regimen`);
        }
      }
    },
    
    // @vuese
    // Add product to regimen based on time (am, pm, or both)
    addProductToRegimen(product, timeOfUse = 'am') {
      // Morning
      if (timeOfUse === 'am') {
        if (this.isProductInMorning(product)) {
          this.flashWarning('Product is already in Morning regimen');
          return;
        }

        if (this.isProductInMorningAsNeeded(product)) {
          this.flashWarning('Product is already in Morning As Needed. Remove it first.');
          return;
        }

        if (this.isProductInEveningAsNeeded(product)) {
          this.flashWarning('Product is in Evening As Needed. Remove it first.');
          return;
        }
      }

      // Evening
      if (timeOfUse === 'pm') {
        if (this.isProductInEvening(product)) {
          this.flashWarning('Product is already in Evening regimen');
          return;
        }

        if (this.isProductInEveningAsNeeded(product)) {
          this.flashWarning('Product is already in Evening As Needed. Remove it first.');
          return;
        }

        if (this.isProductInMorningAsNeeded(product)) {
          this.flashWarning('Product is in Morning As Needed. Remove it first.');
          return;
        }
      }

      // Both
      if (timeOfUse === 'both') {
        if (
          this.isProductInMorning(product) ||
          this.isProductInMorningAsNeeded(product)
        ) {
          this.flashWarning(
            'Product is already in Morning or Morning As Needed.'
          );
          return;
        }

        if (
          this.isProductInEvening(product) ||
          this.isProductInEveningAsNeeded(product)
        ) {
          this.flashWarning(
            'Product is already in Evening or Evening As Needed.'
          );
          return;
        }
      }
      
      const regimenProduct = this.createRegimenProduct(product);
      
      // Add to appropriate section(s)
      if (timeOfUse === 'am') {
        this.insertNewProductByPriority(this.morningProducts, regimenProduct);
        this.flashSuccess(`${product.title} added to Morning regimen`);
      } else if (timeOfUse === 'pm') {
        this.insertNewProductByPriority(this.eveningProducts, regimenProduct);
        this.flashSuccess(`${product.title} added to Evening regimen`);
      } else if (timeOfUse === 'both') {
        this.insertNewProductByPriority(this.morningProducts, regimenProduct);
        this.insertNewProductByPriority(this.eveningProducts, regimenProduct);
        this.flashSuccess(`${product.title} added to Morning and Evening regimen`);
      }
    },
    
    // @vuese
    // Remove product from regimen
    removeProduct(product, section) {
      const targetArray = this.getSectionArray(section);
      if (!targetArray) return;
      
      const index = targetArray.findIndex(p => p.variant_graph_id === product.variant_graph_id);
      if (index !== -1) {
        targetArray.splice(index, 1);
      }
    },

    // @vuese
    // Get array by regimen section
    getSectionArray(section) {
      const sections = {
        morning: this.morningProducts,
        evening: this.eveningProducts,
        'morning-as-needed': this.morningAsNeeded,
        'evening-as-needed': this.eveningAsNeeded
      };

      return sections[section] || null;
    },

    getSectionName(section) {
      switch (section) {
        case 'morning':
          return 'Morning';
        case 'morning-as-needed':
          return 'Morning As Needed';
        case 'evening':
          return 'Evening';
        case 'evening-as-needed':
          return 'Evening As Needed';
        default:
          return section;
      }
    },

    // @vuese
    // Compare products consistently across drag events
    isSameDraggedProduct(productA, productB) {
      if (!productA || !productB) return false;

      const keyA = productA.variant_graph_id || productA.shopify_product_graph_id;
      const keyB = productB.variant_graph_id || productB.shopify_product_graph_id;
      return keyA && keyA === keyB;
    },

    // @vuese
    // Handle drag changes for paginated sections (morning/evening)
    handlePaginatedDragChange(event, section, pageIndex) {
      const targetArray = this.getSectionArray(section);
      if (!targetArray) return;

      const pageOffset = pageIndex * 8;

      if (event.moved) {
        const globalOldIndex = pageOffset + event.moved.oldIndex;
        const globalNewIndex = pageOffset + event.moved.newIndex;
        const [movedItem] = targetArray.splice(globalOldIndex, 1);
        targetArray.splice(globalNewIndex, 0, movedItem);
      }

      // Reorder inside the same paginated section.
      if (event.added && this.draggedSection === section) {
        const draggedIndex = targetArray.findIndex(product =>
          this.isSameDraggedProduct(product, event.added.element)
        );

        if (draggedIndex !== -1) {
          const [draggedItem] = targetArray.splice(draggedIndex, 1);
          let destinationIndex = pageOffset + event.added.newIndex;

          if (draggedIndex < destinationIndex) {
            destinationIndex -= 1;
          }

          destinationIndex = Math.max(0, Math.min(destinationIndex, targetArray.length));
          targetArray.splice(destinationIndex, 0, draggedItem);
        }
      }

      // Move between sections (or from a newly dropped external source).
      if (event.added && this.draggedSection !== section) {
        targetArray.splice(pageOffset + event.added.newIndex, 0, event.added.element);

        const duplicateCount = targetArray.filter(product =>
          product.shopify_product_graph_id === event.added.element.shopify_product_graph_id
        ).length;

        if (duplicateCount > 1) {
          targetArray.splice(pageOffset + event.added.newIndex, 1);
          this.flashWarning(`Product is already in ${this.getSectionName(section)} regimen`);
          // Mark this product as rejected so we don't remove it from source
          this.duplicateRejectedProduct = event.added.element.shopify_product_graph_id;
          return;
        }
        
        // Remove from source section since we're moving to a different section
        const sourceArray = this.getSectionArray(this.draggedSection);
        if (sourceArray) {
          const sourceIndex = sourceArray.findIndex(p =>
            this.isSameDraggedProduct(p, event.added.element)
          );
          if (sourceIndex !== -1) {
            sourceArray.splice(sourceIndex, 1);
          }
        }
      }

      // event.removed is now only for internal tracking - actual removal is handled above
      // This prevents issues with reordering within the same section across pages

      this.updateProductPositions(section);
    },
    
    // @vuese
    // Handle drag change event and check for duplicates
    handleDragChange(event, section) {
      if (event.added) {
        const addedProduct = event.added.element;

        const targetArray = this.getSectionArray(section);
        if (!targetArray) return;
        
        // Check if the product already exists in this section (excluding the one just added)
        const duplicateCount = targetArray.filter(p => 
          p.shopify_product_graph_id === addedProduct.shopify_product_graph_id
        ).length;
        
        if (duplicateCount > 1) {
          // Remove the duplicate that was just added
          const addedIndex = event.added.newIndex;
          targetArray.splice(addedIndex, 1);
          
          // Show warning message
          this.flashWarning(`Product is already in ${this.getSectionName(section)} regimen`);
          this.duplicateRejectedProduct = addedProduct.shopify_product_graph_id;
          return;
        }
      }

      // Remove from source section when moving between sections
      if (event.added && this.draggedSection !== section) {
        const addedProduct = event.added.element;
        const sourceArray = this.getSectionArray(this.draggedSection);

        if (sourceArray) {
          const sourceIndex = sourceArray.findIndex(p =>
            this.isSameDraggedProduct(p, addedProduct)
          );

          if (sourceIndex !== -1) {
            sourceArray.splice(sourceIndex, 1);
          }
        }
      }
      
      // Update positions after successful drag
      this.updateProductPositions(section);
    },
    
    // @vuese
    // Update product positions after drag
    updateProductPositions(section) {
      const targetArray = this.getSectionArray(section);
      if (!targetArray) return;
      
      // Update positions
      targetArray.forEach((product, index) => {
        product.position = index;
      });
    },
    
    // @vuese
    // Handle drag start - track which product is being dragged
    onDragStart(event, section, pageIndex = 0) {
      this.draggedSection = section;
      
      // Get the index from the vuedraggable event
      const oldIndex = event.oldIndex;
      
      const targetArray = this.getSectionArray(section);
      if (!targetArray) return;
      
      if (targetArray && oldIndex !== undefined && targetArray.length > 0) {
        const isPaginatedSection = section === 'morning' || section === 'evening';
        const globalOldIndex = isPaginatedSection ? (pageIndex * 8) + oldIndex : oldIndex;
        this.draggedProduct = targetArray[globalOldIndex];
      }
    },
    
    // @vuese
    // Handle drag end - check if dropped outside and remove
    onDragEnd(event) {
      const { clientX, clientY } = event.originalEvent;

      const container = this.$el.querySelector('.partition-right');
      if (!container) return;
      const rect = container.getBoundingClientRect();

      const droppedOutside =
        clientX < rect.left ||
        clientX > rect.right ||
        clientY < rect.top ||
        clientY > rect.bottom;

      if (droppedOutside && this.draggedProduct && this.draggedSection) {
        this.removeProduct(this.draggedProduct, this.draggedSection);
      }

      this.isDraggingOutside = false;
      this.draggedProduct = null;
      this.draggedSection = null;
      this.duplicateRejectedProduct = null;
    },
    
    // @vuese
    // Handle drag leave partition - mark as outside
    onDragLeavePartition(event) {
      // Check if really leaving (not just moving to child element)
      const rect = event.currentTarget.getBoundingClientRect();
      const x = event.clientX;
      const y = event.clientY;
      
      if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
        if (this.draggedProduct) {
          this.isDraggingOutside = true;
        }
      }
    },
    
    // @vuese
    // Handle drag enter partition - mark as inside
    onDragEnterPartition(event) {
      if (this.draggedProduct) {
        this.isDraggingOutside = false;
      }
    },
    
    // @vuese
    // Handle drop in partition - ensure we're not removing
    onDropInPartition(event) {
      this.isDraggingOutside = false;
    },
    
    // @vuese
    // Toggle product description
    toggleProduct(productId) {
      this.expandedProduct = this.expandedProduct === productId ? null : productId;
    },
    
    // @vuese
    // Open additional information modal
    openAdditionalInfoModal(section) {
      this.currentSection = section;
      this.tempAdditionalInfo = section === 'morning' ? this.morningAdditionalInfo : this.eveningAdditionalInfo;
      this.showAdditionalInfoModal = true;
    },
    
    // @vuese
    // Close additional information modal
    closeAdditionalInfoModal() {
      this.showAdditionalInfoModal = false;
      this.currentSection = null;
      this.tempAdditionalInfo = '';
    },
    
    // @vuese
    // Save additional information
    saveAdditionalInfo() {
      // Validate character limit
      const infoText = this.tempAdditionalInfo || '';
      if (infoText.length > 2203) {
        this.flashWarning('Additional information must not exceed 2203 characters');
        return;
      }
      
      if (this.currentSection === 'morning') {
        this.morningAdditionalInfo = this.tempAdditionalInfo;
      } else if (this.currentSection === 'evening') {
        this.eveningAdditionalInfo = this.tempAdditionalInfo;
      }
      this.closeAdditionalInfoModal();
    },
    
    // @vuese
    // Search products with debounce
    searchProduct() {
      this.isSearching = true;
      this.searchCompleted = false;
      this.query = this.buildFilters();
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getProducts().then(() => {
          this.isSearching = false;
          // Only show "search complete" if there was an actual text search
          if (this.search) {
            this.searchCompleted = true;
            
            // Clear the completed indicator after 2 seconds
            clearTimeout(this.searchCompletedTimeout);
            this.searchCompletedTimeout = setTimeout(() => {
              this.searchCompleted = false;
            }, 2000);
          }
        });
      }, 500);
    },
    
    // @vuese
    // Remove a specific filter
    removeFilter(filterType) {
      switch(filterType) {
        case 'brand':
          this.brand = '';
          break;
        case 'concern':
          this.concern = '';
          break;
        case 'category':
          this.category = '';
          break;
        case 'ingredient':
          this.ingredient = '';
          break;
        case 'search':
          this.search = '';
          break;
      }
      // Use nextTick to ensure the filter components update before triggering search
      this.$nextTick(() => {
        // Use fetchData instead of searchProduct to avoid showing "search complete"
        this.fetchData();
      });
    },
    
    // @vuese
    // Clear all active filters
    clearAllFilters() {
      this.brand = '';
      this.concern = '';
      this.category = '';
      this.ingredient = '';
      this.search = '';
      // Use nextTick to ensure the filter components update before triggering search
      this.$nextTick(() => {
        // Use fetchData instead of searchProduct to avoid showing "search complete"
        this.fetchData();
      });
    },
    
    // @vuese
    // Override fetchData to handle search state
    fetchData() {
      this.isSearching = true;
      this.searchCompleted = false;
      this.query = this.buildFilters();
      this.getProducts().then(() => {
        this.isSearching = false;
      }).catch(() => {
        this.isSearching = false;
      });
    },
    
    // @vuese
    // Change products per page
    changePerPage() {
      this.isSearching = true;
      this.searchCompleted = false;
      this.getProducts().then(() => {
        this.isSearching = false;
      }).catch(() => {
        this.isSearching = false;
      });
    },
    
    // @vuese
    // Complete regimen and save
    async completeRegimen(action = 'preview') {
      if (this.loading) return;
      
      // Build products array with am_position/pm_position
      // Use a map to track products and merge if they're in both AM and PM
      const productMap = new Map();
      
      // Add morning products
      this.morningProducts.forEach((p, index) => {
        const productData = {
          id: p.id || null,
          variant_id: p.variant_id,
          shopify_product_id: p.shopify_product_id,
          title: p.title,
          vendor: p.vendor,
          price: String(p.price || '0'),
          am_position: index + 1,
          pm_position: null,
          am_as_needed_position: null,
          pm_as_needed_position: null,
          shopify_product_graph_id: p.shopify_product_graph_id,
          variant_graph_id: p.variant_graph_id,
          discount_variant_id: p.discount_variant_id,
          handle: p.handle,
          variant_title: p.variant_title,
          sku: p.sku,
          image: p.image,
          usage_instruction: p.usage_instruction || '',
          recomendation_type: p.recomendation_type || 'core',
          time_of_use: 'AM',
          frequency: "One Time",
          selling_plan_id: ""
        };
        
        // Add item_type for prescription badge
        if (p.handle === 'rx' || (p.shopify_product_graph_id && p.shopify_product_graph_id.startsWith('rx-'))) {
          productData.item_type = 'prescription_badge';
        }
        
        // Use a unique key for the map - for RX products with empty/null IDs, use the product's database ID
        const mapKey = this.getMapKey(p);
        
        productMap.set(mapKey, productData);
      });
      
      // Add evening products (merge if already in morning)
      this.eveningProducts.forEach((p, index) => {
        // Use the same key logic as morning products for consistency
        const mapKey = this.getMapKey(p);
        
        const existingProduct = productMap.get(mapKey);
        
        if (existingProduct) {
          // Product is in both AM and PM - merge them
          existingProduct.pm_position = index + 1;
          existingProduct.time_of_use = 'AM/PM';
        } else {
          // Product is only in PM
          const productData = {
            id: p.id || null,
            variant_id: p.variant_id,
            shopify_product_id: p.shopify_product_id,
            title: p.title,
            vendor: p.vendor,
            price: String(p.price || '0'),
            am_position: null,
            pm_position: index + 1,
            am_as_needed_position: null,
            pm_as_needed_position: null,
            shopify_product_graph_id: p.shopify_product_graph_id,
            variant_graph_id: p.variant_graph_id,
            discount_variant_id: p.discount_variant_id,
            handle: p.handle,
            variant_title: p.variant_title,
            sku: p.sku,
            image: p.image,
            usage_instruction: p.usage_instruction || '',
            recomendation_type: p.recomendation_type || 'core',
            time_of_use: 'PM',
            frequency: "One Time",
            selling_plan_id: ""
          };
          
          // Add item_type for prescription badge
          if (p.handle === 'rx' || (p.shopify_product_graph_id && p.shopify_product_graph_id.startsWith('rx-'))) {
            productData.item_type = 'prescription_badge';
          }
          
          productMap.set(mapKey, productData);
        }
      });

      // Morning As Needed
      this.morningAsNeeded.forEach((p, index) => {
        // Use the same key logic as morning products for consistency
        const mapKey = this.getMapKey(p);
        
        const existingProduct = productMap.get(mapKey);
        
        if (existingProduct) {
          // Product is in both AM and PM - merge them
          existingProduct.am_as_needed_position = index + 1;
          existingProduct.am_position = null;
          existingProduct.time_of_use = 'As Needed';
        } else {
          // Product is only in PM
          const productData = {
            id: p.id || null,
            variant_id: p.variant_id,
            shopify_product_id: p.shopify_product_id,
            title: p.title,
            vendor: p.vendor,
            price: String(p.price || '0'),
            am_position: null,
            pm_position: null,
            am_as_needed_position: index + 1,
            pm_as_needed_position: null,
            shopify_product_graph_id: p.shopify_product_graph_id,
            variant_graph_id: p.variant_graph_id,
            discount_variant_id: p.discount_variant_id,
            handle: p.handle,
            variant_title: p.variant_title,
            sku: p.sku,
            image: p.image,
            usage_instruction: p.usage_instruction || '',
            recomendation_type: p.recomendation_type || 'core',
            time_of_use: 'As Needed',
            frequency: "One Time",
            selling_plan_id: ""
          };
          
          // Add item_type for prescription badge
          if (p.handle === 'rx' || (p.shopify_product_graph_id && p.shopify_product_graph_id.startsWith('rx-'))) {
            productData.item_type = 'prescription_badge';
          }
          
          productMap.set(mapKey, productData);
        }
      });

      // Evening As Needed
      this.eveningAsNeeded.forEach((p, index) => {
        // Use the same key logic as morning products for consistency
        const mapKey = this.getMapKey(p);
        
        const existingProduct = productMap.get(mapKey);
        
        if (existingProduct) {
          // Product is in both AM and PM - merge them
          existingProduct.pm_as_needed_position = index + 1;
          existingProduct.pm_position = null;
          existingProduct.time_of_use = 'As Needed';
        } else {
          // Product is only in PM
          const productData = {
            id: p.id || null,
            variant_id: p.variant_id,
            shopify_product_id: p.shopify_product_id,
            title: p.title,
            vendor: p.vendor,
            price: String(p.price || '0'),
            am_position: null,
            pm_position: null,
            am_as_needed_position: null,
            pm_as_needed_position: index + 1,
            shopify_product_graph_id: p.shopify_product_graph_id,
            variant_graph_id: p.variant_graph_id,
            discount_variant_id: p.discount_variant_id,
            handle: p.handle,
            variant_title: p.variant_title,
            sku: p.sku,
            image: p.image,
            usage_instruction: p.usage_instruction || '',
            recomendation_type: p.recomendation_type || 'core',
            time_of_use: 'As Needed',
            frequency: "One Time",
            selling_plan_id: ""
          };
          
          // Add item_type for prescription badge
          if (p.handle === 'rx' || (p.shopify_product_graph_id && p.shopify_product_graph_id.startsWith('rx-'))) {
            productData.item_type = 'prescription_badge';
          }
          
          productMap.set(mapKey, productData);
        }
      });

      
      const products = Array.from(productMap.values());
      
      if (products.length === 0) {
        return;
      }
      
      this.loading = true;
      this.loadingAction = action;
      try {
        // Use getRequestPracticeId() which correctly checks for super admin role
        const practiceParam = this.getRequestPracticeId();
        
        // Call bulk_upsert API with new payload format
        const payload = {
          morning_instructions: this.morningAdditionalInfo || '',
          evening_instructions: this.eveningAdditionalInfo || '',
          products: products
        };
        
        await RegimenService.bulkUpsertRegimenProducts(
          payload,
          this.regimenId,
          practiceParam
        );

        await this.$store.dispatch(UPDATE_PATIENT, {
          id: this.patientId,
          patient: {regimen_from_quiz: false},
          practiceId: this.getRequestPracticeId()
        });

        this.flashSuccess('You updated client regimen');
        await this.loadRegimenProducts();
        if(action == "preview"){
          // Open PDF download in new window
          const pdfUrl = practiceParam 
            ? `/api/su/practices${practiceParam}/regimens/${this.regimenId}/download_pdf`
            : `/api/practice/regimens/${this.regimenId}/download_pdf`;
          window.open(pdfUrl, '_blank');
        }else if(action == 'email_regimen'){
          const resp = await this.$store.dispatch(
            SEND_REGIMEN,
            {
              id: this.patient.id,
              practiceId: this.getRequestPracticeId(),
              emailType: 'am_pm'
            }
          );

          if (resp.status === 204) {
            this.flashSuccess(
              'You’ve emailed your client their regimen. It should arrive in under 5 minutes.'
            );
          } 
        }
      }
      catch(error)
      {
        console.error('Failed to update regimen:', error);
      }
      finally
      {
        this.loading = false;
        this.loadingAction = null;
      }
    },
    
    // @vuese
    // Get practice ID for super admin user
    getRequestPracticeId() {
      return this.isRole('super_admin') && this.patient?.practice?.id ? `/${this.patient.practice.id}` : '';
    },


    handlePresetProduct({ product, section }) {
      this.addProductToRegimen(product, section);
    },

    getMapKey(product) {
      return product.handle === 'rx' && product.id
        ? `rx-db-${product.id}`
        : product.shopify_product_graph_id;
    },

    checkMove(evt) {
      const product = evt.draggedContext.element;
      const fromSection = evt.from.dataset.section;
      const targetSection = evt.to.dataset.section;

      let existsInMorning = this.morningProducts.some(
        p => p.shopify_product_graph_id === product.shopify_product_graph_id
      );

      let existsInEvening = this.eveningProducts.some(
        p => p.shopify_product_graph_id === product.shopify_product_graph_id
      );

      let existsInMorningAsNeeded = this.morningAsNeeded.some(
        p => p.shopify_product_graph_id === product.shopify_product_graph_id
      );

      let existsInEveningAsNeeded = this.eveningAsNeeded.some(
        p => p.shopify_product_graph_id === product.shopify_product_graph_id
      );

      if (this.draggedSection === 'morning') {
        existsInMorning = false;
      }

      if (this.draggedSection === 'evening') {
        existsInEvening = false;
      }

      if (this.draggedSection === 'morning-as-needed') {
        existsInMorningAsNeeded = false;
      }

      if (this.draggedSection === 'evening-as-needed') {
        existsInEveningAsNeeded = false;
      }

      const isInMain = existsInMorning || existsInEvening;
      const isInAsNeeded = existsInMorningAsNeeded || existsInEveningAsNeeded;

      const movingToMain =
        targetSection === 'morning' ||
        targetSection === 'evening';

      const movingToAsNeeded =
        targetSection === 'morning-as-needed' ||
        targetSection === 'evening-as-needed';

      // Can't move to Main while product exists in any As Needed
      if (movingToMain && isInAsNeeded) {
        this.flashWarning(
          'Remove the product from As Needed before moving it to Morning or Evening.'
        );
        return false;
      }

      // Can't move to As Needed while product exists in any Main
      if (movingToAsNeeded && isInMain) {
        this.flashWarning(
          'Remove the product from Morning or Evening before moving it to As Needed.'
        );
        return false;
      }

      return true;
    },

    isRxProduct(product) {
      return (
        product?.handle === 'rx' ||
        product?.item_type === 'prescription_badge' ||
        product?.shopify_product_graph_id?.startsWith('rx-')
      );
    },

    getProductType(product) {
      const rawType = product?.productType || product?.product_type || '';

      if (!rawType) return null;

      const value = rawType.trim().toLowerCase();

      if (/cleanser|exfoliator|toner/.test(value)) {
        return 'Cleansers, Exfoliators, and Toners';
      }

      if (/antioxidant/.test(value)) {
        return 'Antioxidants';
      }

      if (/brightener/.test(value)) {
        return 'Brighteners';
      }

      if (/spot treatment|targeted treatment/.test(value)) {
        return 'Spot Treatments';
      }

      if (/treatment product/.test(value)) {
        return 'Treatment Products';
      }

      if (/eye care/.test(value)) {
        return 'Eye Care';
      }

      if (/retinol/.test(value)) {
        return 'Retinols';
      }

      if (/moisturizer|moisterizer/.test(value)) {
        return 'Moisturizers';
      }

      if (/sun protection/.test(value)) {
        return 'Sun Protection';
      }

      if (/mask/.test(value)) {
        return 'Masks';
      }

      if (/neck/.test(value)) {
        return 'Neck and Décolletage';
      }

      if (/hair/.test(value)) {
        return 'Hair Care';
      }

      if (/tool/.test(value)) {
        return 'Tools and Devices';
      }

      if (/body/.test(value)) {
        return 'Body Care';
      }

      if (/lip/.test(value)) {
        return 'Lip Care';
      }

      if (/kit/.test(value)) {
        return 'Kits and Value Sets';
      }

      if (/thinning hair/.test(value)) {
        return 'Thinning Hair';
      }

      return null;
    },

    getProductPriority(product) {
      // Rx always comes first
      if (this.isRxProduct(product)) {
        return 0;
      }

      const specialProductIds = [
        '7466850254988'
      ];

      const shopifyProductId = product?.shopify_product_id
        ? String(product.shopify_product_id)
        : this.extractShopifyProductId(product?.shopify_product_graph_id);

      // Special products have priority 2 in Rails
      if (specialProductIds.includes(shopifyProductId)) {
        return 2;
      }

      const priorityMapping = {
        'Cleansers, Exfoliators, and Toners': 1,
        'Antioxidants': 3,
        'Brighteners': 4,
        'Spot Treatments': 4,
        'Treatment Products': 4,
        'Eye Care': 5,
        'Retinols': 6,
        'Moisturizers': 7,
        'Sun Protection': 8
      };

      const normalizedType = this.getProductType(product);

      return priorityMapping[normalizedType] || 9;
    },

    extractShopifyProductId(graphId) {
      if (!graphId) return null;

      return String(graphId).split('/').pop();
    },

    getProductPrice(product) {
      return parseFloat(product?.price || 0);
    },

    insertNewProductByPriority(products, newProduct) {
      const newPriority = this.getProductPriority(newProduct);

      let insertIndex = 0;
      let highestLowerPriority = -Infinity;

      products.forEach((product, index) => {
        const priority = this.getProductPriority(product);

        if (
          priority < newPriority &&
          priority > highestLowerPriority
        ) {
          highestLowerPriority = priority;
          insertIndex = index + 1;
        }
      });

      if (highestLowerPriority !== -Infinity) {
        products.forEach((product, index) => {
          if (this.getProductPriority(product) === highestLowerPriority) {
            insertIndex = index + 1;
          }
        });
      }

      products.splice(insertIndex, 0, newProduct);

      products.forEach((product, index) => {
        product.position = index;
      });
    }
  }
};
</script>